import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AddIcon from "@mui/icons-material/Add";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DashboardIcon from "@mui/icons-material/Dashboard";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import NavigateBeforeOutlinedIcon from "@mui/icons-material/NavigateBeforeOutlined";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import TableRowsIcon from "@mui/icons-material/TableRows";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Card,
  CardMedia,
  Container,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import { groupBy, uniq } from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import api from "../../../redux/actions/api";
import {
  checkedCallInApi,
  checkedInApi,
  clinicReassignAppointment,
  clinicRescheduleAppointment,
  getAppointmentsByClinicAndFilter,
  getAppointmentsByVetIdAndDate,
  getAppointsmentsByClinic,
  getAvailabilityByVetIdAndType,
  getVetAppointmentsByIdAndFilter,
  updateAppointmentStatusById,
  updateCancel,
  updateCompleted,
  updateFinalize,
} from "../../../redux/reducers/clinicSlice";
import { getVetHolidaysById } from "../../../redux/reducers/doctorSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import { getMedicalHistoryByPetId } from "../../../redux/reducers/medicalHistorySlice";
import { storeApntmntScreenDetails } from "../../../redux/reducers/mixedSlice";
import { admitPet } from "../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import {
  appointmentLaterList,
  appointmentList,
  bookingTypes,
  homeVisitStatusList,
  physicalStatusList,
  serviceTypes,
  typeList,
  virtualStatusList,
} from "../../../util/dropList";
import {
  adjustTime,
  createTimeSlots,
  getAllDatesFromArray,
  getClassNameForCalendar,
  getDateList,
  getDatesInRange,
  getHourRanges,
  getRequiredSlotList,
  getTimeDiffInMins,
  getTypeByAppointmentType,
  getUpcoming60Dates,
  getWeekRange,
  isTimeBetween,
} from "../../../util/function";
import { tblGrayBack } from "../../../util/object";
import { superTailsClinicId } from "../../../util/server";
import BookAnAppointment from "../../CommonScreens/BookAppointmentment/BookAnAppointment";
import VetBookAnAppointment from "../../CommonScreens/BookAppointmentment/VetBookAnAppointment";
import MedicalHistoryView from "../ClinicPetDetails/MedicalHistory/MedicalHistoryView";

const tblHdrs = [
  "petName",
  "appointmentType",
  "serviceType",
  "vetName",
  "apntDate",
  "status",
  "action",
];
const nameExpan = {
  petName: "Pet Name",
  appointmentType: "Consultation Type",
  serviceType: "Service Type",
  vetName: "Vet Name",
  apntDate: "Appt Date/Time",
  status: "Status",
  action: "",
};
const admitReqList = ["remark", "vet"];
const allObj = { name: "All", value: "all" };
const initCons = ["Physical", "Virtual", "Home"];
const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};
const initTimeObj = { times: [], ids: [] };
const initSearch = {
  petName: "",
  selectedVet: allObj,
  consultationType: [],
  status: [],
};
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const filterByList = [
  "Type",
  "Username",
  "Appt Date",
  "Appt Time",
  "Service Type",
];

const statusMap = {
  Upcoming: "scheduled",
  "Checked-in": "inprogress",
  "In Transit": "intransit",
  Consultation: "consultation",
  Billing: "finalize",
  Completed: "completed",
  Cancelled: "cancelled",
};

const NewCalendar = () => {
  const timeRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [petData, setPetData] = useState(null);
  const [vetDropList, setVetDropList] = useState([allObj]);
  const [selectedVet, setSelectedVet] = useState(allObj);
  const [selectedType, setSelectedType] = useState("date");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [calDate, setCalDate] = useState(new Date());
  const [weekDate, setWeekDate] = useState(new Date());
  const [timeList, setTimeList] = useState([]);
  const [dateList, setDateList] = useState([]);
  const [conTypes, setConTypes] = useState(initCons);
  const [reqApnts, setReqApnts] = useState(null);
  const [sleServiceTypes, setSelServiceTypes] = useState(["All"]);
  const [anchorEls, setAnchorEls] = useState({});
  const [slctedApnt, setSlctedApnt] = useState(null);
  const [reSchReAssModVsble, setReSchReAssModVsble] = useState(false);
  const [canModVsble, setCanModVsble] = useState(false);
  const [admitModVsble, setAdmitModVsble] = useState(false);
  const [modValues, setModValues] = useState({});
  const [modErrs, setModErrs] = useState({});
  const [selectTime, setSelectTime] = useState(null);
  const [holidayDates, setHolidayDates] = useState([]);
  const [timeObject, setTimeObject] = useState(initTimeObj);
  const [flowModVsble, setFlowModVsble] = useState(false);
  const [apntBookModVsble, setApntBookModVsble] = useState(false);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [srchValue, setSrchValue] = useState("");
  const [isTableView, setTableView] = useState(false);
  const [assignVetModVisible, setAssignVetModVisible] = useState(false);
  const [assignVetvalues, setAssignVetValues] = useState({});
  const [slctedApntStatus, setSlctedApntStatus] = useState({
    name: "All",
    value: "All",
  });
  const [filterValues, setFilterValues] = useState(initFilter);
  const {
    userDetails,
    appointments,
    vetAppointments,
    vetTodayAppointments,
    todayAppointments,
    vetBookedApnts,
    vetAvailability,
    appointmentsByFilter,
    details: clinicDetails,
    facilities,
  } = useSelector((state) => state?.clinic);
  const [vetList, setVetList] = useState(appointments?.doctors);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const clinicHolidays = useSelector((state) => state?.clinic?.holidays);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const pets = useSelector((state) => state.pet.clinicPets);
  const appointmentLists = appointments?.data;
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = JSON.parse(user);

  useEffect(() => {
    getDateAndTimeLists();
    dispatch(getClinicVets("?type=all"));
    setFilterValues({ ...initFilter, selectedList: [], values: {} });
  }, []);

  useEffect(() => {
    if (timeRef?.current) {
      timeRef?.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [timeList]);

  useEffect(() => {
    const reqVetList = clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : userDetails?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
    });
    reqVetList?.unshift(allObj);
    setVetDropList(reqVetList);
  }, [clinicVets]);

  useEffect(() => {
    handleApiCall();
    //for storing details to call socket
    dispatch(
      storeApntmntScreenDetails({
        selectedVet,
        selectedType,
        selectedDate,
      })
    );
  }, [selectedType, selectedDate, weekDate]);

  useEffect(() => {
    getReqAppointments();
    const reqVets = [...(appointments?.doctors ?? [])];
    if (
      role !== "ROLE_CLINIC" &&
      (appointments?.doctors?.length === 0 || !appointments?.doctors)
    ) {
      reqVets.push({
        name: profile?.name,
        value: profile?.id,
        id: profile?.id,
        doctorId: profile?.id,
      });
    }
    if (role === "ROLE_CLINIC") {
      reqVets.unshift({
        name: profile?.name,
        value: profile?.id,
        id: profile?.id,
        doctorId: profile?.id,
      });
    }
    setVetList(reqVets);
  }, [appointmentLists, vetAppointments]);

  useEffect(() => {
    if (
      slctedApnt?.reAssign ||
      !(modValues?.vet?.doctorId ?? modValues?.vet?.value) ||
      !modValues?.date ||
      !modValues?.appointmentOption
    ) {
      return;
    }
    if (modValues?.appointmentOption === "Later") {
      dispatch(
        getVetHolidaysById(modValues?.vet?.doctorId ?? modValues?.vet?.value)
      );
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId: modValues?.vet?.doctorId ?? modValues?.vet?.value,
          type: slctedApnt?.appointmentType ?? modValues?.consultationMode,
        })
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId: modValues?.vet?.doctorId ?? modValues?.vet?.value,
          date: moment(new Date(modValues?.date)).format("YYYY-MM-DD"),
          clinicId: profile?.id,
        })
      );
    }
  }, [
    modValues?.vet?.value,
    modValues?.date,
    modValues?.appointmentOption,
    modValues?.consultationMode,
  ]);

  useEffect(() => {
    getHolidayDateList();
  }, [holidays, clinicHolidays, vetAvailability]);

  const getFilterObj = (reset = false) => {
    const reqObj = { page: 1, itemSize: 50 };
    if (reset) return reqObj;
    if (searchValues?.selectedVet?.value !== "all") {
      reqObj.vetId = searchValues?.selectedVet?.value;
    }
    if (searchValues?.petName?.length > 0)
      reqObj.petName = searchValues?.petName;
    // if (searchValues?.vetName?.length > 0)
    //   reqObj.vetName = searchValues?.vetName;
    if (searchValues?.consultationType?.length > 0)
      reqObj.consultationType = searchValues?.consultationType?.map(
        (li) => li?.value
      );
    if (searchValues?.status?.length > 0)
      reqObj.status = searchValues?.status?.includes("All")
        ? ["all"]
        : searchValues?.status?.map((li) => statusMap[li?.value] || li?.value);
    if (filterValues?.selectedList?.includes("Type")) {
      reqObj.immediate = filterValues?.values?.Type === "Immediate";
    }
    if (filterValues?.values?.Username?.length > 0) {
      reqObj.username = filterValues?.values?.Username;
    }
    if (filterValues?.selectedList?.includes("Service Type")) {
      reqObj.serviceType =
        filterValues?.values?.["Service Type"]?.map((li) => li?.value) ?? [];
    }
    if (filterValues?.selectedList?.includes("Appt Date")) {
      reqObj.startDate = moment(
        new Date(filterValues?.values?.["Start Date"] ?? new Date())
      ).format("YYYY-MM-DD");
      reqObj.endDate = moment(
        new Date(filterValues?.values?.["End Date"] ?? new Date())
      ).format("YYYY-MM-DD");
    }
    if (filterValues?.selectedList?.includes("Appt Time")) {
      reqObj.startTime = moment(
        new Date(filterValues?.values?.["Start Time"] ?? new Date())
      ).format("HH:mm");
      reqObj.endTime = moment(
        new Date(filterValues?.values?.["End Time"] ?? new Date())
      ).format("HH:mm");
    }
    return reqObj;
  };

  useEffect(() => {
    if (!isTableView) return;
    // const hasSearchValues =
    //   searchValues?.petName?.trim() ||
    //   (searchValues?.consultationType &&
    //     searchValues?.consultationType?.length > 0) ||
    //   (searchValues?.status && searchValues?.status?.length > 0) ||
    //   searchValues?.selectedVet?.value;
    // if (hasSearchValues) {
    onCalendarApiCall();
    // }
  }, [
    isTableView,
    searchValues?.petName,
    // searchValues?.vetName,
    searchValues?.consultationType,
    searchValues?.status,
    searchValues?.selectedVet?.value,
  ]);

  const onCalendarApiCall = (reset = false) => {
    dispatch(getAppointmentsByClinicAndFilter(getFilterObj(reset)));
  };

  const handleApiCall = () => {
    if (isTableView) {
      onCalendarApiCall();
    } else {
      if (selectedVet?.value === "all") {
        let url = `?type=${selectedType}`;
        if (selectedType === "date") {
          url = url + `&date=${moment(selectedDate).format("YYYY-MM-DD")}`;
        }
        if (selectedType === "week") {
          url = `${url}&currentDate=${getWeekRange(weekDate)?.startDate}`;
          const reqDates = getDatesInRange(
            new Date(getWeekRange(weekDate)?.startDate),
            new Date(getWeekRange(weekDate)?.endDate)
          );
          setDateList(reqDates);
        }
        dispatch(getAppointsmentsByClinic(url));
      } else {
        let url = `${selectedVet?.value}?type=${selectedType}`;
        if (selectedType === "date") {
          url = url + `&date=${moment(selectedDate).format("YYYY-MM-DD")}`;
        }
        if (selectedType === "week") {
          url = `${url}&currentDate=${getWeekRange(weekDate)?.startDate}`;
          const reqDates = getDatesInRange(
            new Date(getWeekRange(weekDate)?.startDate),
            new Date(getWeekRange(weekDate)?.endDate)
          );
          setDateList(reqDates);
        }
        dispatch(getVetAppointmentsByIdAndFilter(url));
      }
    }
  };

  const getHolidayDateList = () => {
    if (
      (holidays?.length === 0 || !holidays) &&
      (clinicHolidays?.length === 0 || !clinicHolidays) &&
      vetAvailability?.every((li) => li?.status)
    ) {
      return setHolidayDates([]);
    }
    const vetDates = getAllDatesFromArray(holidays) ?? [];
    const cliHolidays =
      clinicHolidays?.map((hl) => {
        return hl?.date;
      }) ?? [];
    const unAvilableDates =
      vetAvailability?.length > 0 ? getUpcoming60Dates(vetAvailability) : [];
    const mergedArray = vetDates?.concat(cliHolidays, unAvilableDates);
    setHolidayDates(uniq(mergedArray));
  };

  const getVetList = () => {
    return clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
  };

  const checkIsVet = (apntVetId = null) => {
    if (!apntVetId) return false;
    return clinicVets?.some((li) =>
      li?.doctorId === apntVetId && li?.userType?.length > 0
        ? li?.userType?.some((ut) => ut?.name === "ROLE_DOCTOR")
        : false
    );
  };

  const getReqAppointments = () => {
    const listToFilter =
      selectedVet?.value === "all" ? appointmentLists : vetAppointments;
    const reqList = [];
    timeList?.forEach((tm) => {
      listToFilter?.forEach((sl) => {
        const timeBet = isTimeBetween(
          sl?.startTime ?? moment(sl?.appointmentdateTime).format("HH:mm"),
          tm
        );
        if (timeBet) {
          if (sl?.serviceType === "Surgery") {
            const hrRange = getHourRanges([
              sl?.startTime ?? moment(sl?.appointmentdateTime).format("HH:mm"),
              sl?.endTime,
            ]);
            if (hrRange?.length > 0) {
              hrRange?.forEach((hr) => {
                reqList.push({ ...sl, time: hr });
              });
            }
          } else {
            reqList.push({ ...sl, time: `${tm}-${tm?.split(":")?.[0]}:59` });
          }
        }
      });
    });
    setReqApnts(groupBy(reqList, "time"));
  };

  const getDateAndTimeLists = () => {
    const reqTimes = createTimeSlots("00:00", "23:59", 60);
    setTimeList(reqTimes);
    const dates = getDateList();
    setDateList(dates);
  };

  const handleChangeVet = (value) => {
    const reqVal = value ?? allObj;
    setSelectedVet(reqVal);
    if (!isTableView) {
      if (reqVal?.value === "all") {
        dispatch(
          getAppointsmentsByClinic(
            `?type=${selectedType}${
              selectedType === "date"
                ? `&date=${moment(selectedDate).format("YYYY-MM-DD")}`
                : ""
            }`
          )
        );
        dispatch(getAppointsmentsByClinic(`?type=today`));
      } else {
        dispatch(
          getVetAppointmentsByIdAndFilter(
            `${reqVal?.value}?type=${selectedType}${
              selectedType === "date"
                ? `&date=${moment(selectedDate).format("YYYY-MM-DD")}`
                : ""
            }`
          )
        );
        dispatch(
          getVetAppointmentsByIdAndFilter(`${reqVal?.value}?type=today`)
        );
      }
    }
  };

  const handleChangeCheckbox = (name) => {
    const isPrev = conTypes?.find((con) => con === name);
    const reqCons = isPrev
      ? conTypes?.filter((con) => con !== name)
      : [...conTypes, name];
    setConTypes(reqCons);
  };

  const handleServiceTypes = (name) => {
    const isPrev = sleServiceTypes?.find((con) => con === name);
    if (name === "All") {
      setSelServiceTypes(["All"]);
    } else {
      let reqCons = isPrev
        ? sleServiceTypes?.filter((con) => con !== name)
        : [...sleServiceTypes, name];
      reqCons = reqCons?.filter((con) => con !== "All");
      if (reqCons?.length === 0) reqCons = ["All"];
      setSelServiceTypes(reqCons);
    }
  };

  const handleDateChange = (value) => {
    const reqDate = new Date(selectedDate);
    reqDate.setDate(
      value === "add" ? reqDate.getDate() + 1 : reqDate.getDate() - 1
    );
    setSelectedDate(reqDate);
    setCalDate(reqDate);
  };

  const handleWeekChange = (value) => {
    if (value === "add") {
      setWeekDate(getWeekRange(weekDate, 1).startDate);
    } else {
      setWeekDate(getWeekRange(weekDate, -1).startDate);
    }
  };

  const handleSelectWeek = () => {
    setWeekDate(getWeekRange(new Date())?.startDate);
    setSelectedType("week");
    setAnchorEls({});
  };

  const navDetailsPage = (det) => {
    navigate(`/clinic-pet-details`, {
      state: { appointment: { appoinment: det } },
    });
  };

  const handleClick = (id) => {
    setAnchorEls((prev) => ({ ...prev, [id]: true }));
  };

  const handleClose = (id) => {
    setAnchorEls((prev) => ({ ...prev, [id]: false }));
  };

  const getFilteredList = (list) => {
    const reqList =
      list?.filter((li) => {
        const conTypMatch = conTypes?.includes(li?.appointmentType);
        const serMatch = sleServiceTypes?.includes("All")
          ? true
          : sleServiceTypes?.includes(li?.serviceType);
        return conTypMatch && serMatch;
      }) ?? [];
    return reqList ?? [];
  };

  const getTableFilteredList = () => {
    const statVal = slctedApntStatus?.value;
    const reqList =
      (selectedVet?.value === "all"
        ? isTableView
          ? appointmentsByFilter?.data
          : appointmentLists
        : isTableView
        ? appointmentsByFilter?.data
        : vetAppointments
      )?.filter((li) => {
        const statLower =
          li?.appointmentStatus?.toLowerCase() ??
          li?.appoinment?.appointmentStatus?.toLowerCase();
        const searchMatch =
          srchValue?.length > 0
            ? (li?.petName ?? li?.appoinment?.petName)
                ?.toLowerCase()
                ?.includes(srchValue?.toLowerCase()) ||
              (li?.appointmentType ?? li?.appoinment?.appointmentType)
                ?.toLowerCase()
                ?.includes(srchValue?.toLowerCase()) ||
              (li?.serviceType ?? li?.appoinment?.serviceType)
                ?.toLowerCase()
                ?.includes(srchValue?.toLowerCase()) ||
              (li?.doctorName ?? li?.appoinment?.doctorName)
                ?.toLowerCase()
                ?.includes(srchValue?.toLowerCase())
            : true;
        const statusMat =
          statVal !== "All"
            ? (statVal === "Upcoming" && statLower === "scheduled") ||
              (statVal === "Checked-in" && statLower === "inprogress") ||
              (statVal === "In Transit" && statLower === "intransit") ||
              (statLower === "consultation" && statVal === "Consultation") ||
              (statVal === "Billing" && statLower === "finalize") ||
              (statVal === "Completed" && statLower === "completed") ||
              (statVal === "Cancelled" &&
                (statLower === "canceled" || statLower === "cancelled"))
            : true;
        const conTypMatch = conTypes?.includes(
          li?.appointmentType ?? li?.appoinment?.appointmentType
        );
        const serMatch = sleServiceTypes?.includes("All")
          ? true
          : sleServiceTypes?.includes(li?.serviceType);
        return searchMatch && statusMat && conTypMatch && serMatch;
      }) ?? [];
    return reqList?.map((li) => ({ ...li, ...(li?.appoinment ?? {}) })) ?? [];
  };

  const onChangeCalDate = (e) => {
    const { value } = e?.target;
    let reqType = "today";
    if (selectedType !== "week") {
      if (
        moment(new Date(value))?.format("YYYY-MM-DD") !==
        moment(new Date()).format("YYYY-MM-DD")
      ) {
        setSelectedDate(new Date(value));
        reqType = "date";
      }
    }
    if (selectedType === "week") {
      reqType = "week";
      setWeekDate(getWeekRange(value).startDate);
    }
    setSelectedType(reqType);
    setCalDate(new Date(value));
  };

  const handleSelectDay = () => {
    setSelectedType("date");
    setCalDate(selectedDate);
    setAnchorEls({});
  };

  const onCloseCancelMod = () => {
    setSlctedApnt(null);
    setCanModVsble(false);
    setAnchorEls({});
  };

  const conCancel = () => {
    dispatch(updateCancel(slctedApnt?.appointmentId)).then((res) => {
      if (res?.payload) onCloseCancelMod();
    });
  };

  const handleCancel = (apnt) => {
    setSlctedApnt(apnt);
    setCanModVsble(true);
  };

  const handleReschdule = (apnt) => {
    setModValues({
      ...modValues,
      date: new Date(apnt?.appointmentDate),
      appointmentOption: "Later",
      vet: vetDropList?.find((vl) => vl?.value === apnt?.doctorId),
    });
    setSlctedApnt({ ...apnt, reAssign: false });
    setReSchReAssModVsble(true);
  };

  const handleReassign = (apnt) => {
    setModValues({
      ...modValues,
      date: new Date(apnt?.appointmentDate),
      appointmentOption: "Later",
      vet: vetDropList?.find((vl) => vl?.value === apnt?.doctorId),
    });
    setSlctedApnt({ ...apnt, reAssign: true });
    setReSchReAssModVsble(true);
  };

  const onCheckInTransit = (
    apnt,
    vetId = null,
    facilityId = null,
    facilityName = null
  ) => {
    if (apnt?.appointmentType === "Home") {
      if (
        // clinicDetails?.id === apnt?.doctorId &&
        // !checkIsVet(profile?.id) &&
        !vetId
      ) {
        const reqVet =
          clinicDetails?.id === apnt?.doctorId &&
          !checkIsVet(apnt?.doctorId) &&
          !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apnt?.doctorId)
                    ? apnt?.doctorId
                    : checkIsVet(profile?.id)
                    ? profile?.id
                    : null)
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apnt?.doctorId &&
            !checkIsVet(apnt?.doctorId) &&
            !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apnt?.doctorName,
                  value: reqVet?.doctorId ?? apnt?.doctorId,
                  id: reqVet?.doctorId ?? apnt?.doctorId,
                },
          facility: apnt?.facilityId
            ? {
                name: apnt?.facility ?? "",
                value: apnt?.facilityId,
                id: apnt?.facilityId,
              }
            : null,
        });
        setSlctedApnt(apnt);
        setAssignVetModVisible(true);
        return;
      }
      dispatch(
        updateAppointmentStatusById({
          appointmentId: apnt?.appointmentId,
          status: "intransit",
          successMsg: "Patient has been notified!",
        })
      ).then((res) => {
        if (res?.payload) {
          // if (clinicDetails?.id === apnt?.doctorId) {
          const data = { facilityId, facilityName, doctorId: vetId };
          // if (!checkIsVet(apnt?.doctorId) && vetId) {
          //   data.doctorId = vetId;
          // } else if (checkIsVet(profile?.id)) {
          //   data.doctorId = profile?.id;
          // } else {
          //   handleApiCall();
          //   setAnchorEls({});
          //   return;
          // }
          dispatch(
            clinicReassignAppointment({
              appointmentId: apnt?.appointmentId,
              data,
            })
          ).then((reRes) => {
            if (reRes?.payload) {
              onCloseAssignVetMod();
              handleApiCall();
              setAnchorEls({});
              return;
            } else {
              onCloseAssignVetMod();
            }
          });
          // }
          handleApiCall();
          setAnchorEls({});
        }
      });
    } else {
      const data = {
        appointmentId: apnt?.appointmentId,
        doctorId: apnt?.doctorId,
      };
      dispatch(checkedInApi(data)).then((res) => {
        if (res?.payload) {
          handleApiCall();
          setAnchorEls({});
        }
      });
    }
  };

  const onCloseAdmitMod = () => {
    setAdmitModVsble(false);
    setSlctedApnt(null);
    setAnchorEls({});
  };

  const handleModValueChange = (name, value) => {
    const reqValue = (
      typeof value === "object" ? value?.doctorId ?? value?.value : value
    )?.toString();
    setModValues({ ...modValues, [name]: value });
    setModErrs({
      ...modErrs,
      [name]: admitReqList?.includes(name)
        ? reqValue?.length > 0
          ? ""
          : "This field is required"
        : "",
    });
  };

  const handleAdmitPatient = () => {
    let errs = {};
    admitReqList?.forEach((name) => {
      const reqValue = (
        typeof modValues?.[name] === "object"
          ? modValues?.[name]?.doctorId ?? modValues?.[name]?.value
          : modValues?.[name]
      )?.toString();
      errs = {
        ...errs,
        [name]: reqValue?.length > 0 ? "" : "This field is required",
      };
      setModErrs(errs);
    });
    if (Object.values(errs).some((err) => err?.length > 0)) return;
    const data = {
      appointmentId: slctedApnt?.appointmentId,
      kennelNumber: modValues?.kennelNumber ?? "",
      remark: modValues?.remark,
    };
    dispatch(
      admitPet({
        petId: slctedApnt?.petId,
        vetId: modValues?.vet?.value,
        data,
      })
    ).then((res) => {
      if (res?.payload) {
        handleApiCall();
        onCloseAdmitMod();
      }
    });
  };

  const handleAdmit = (apnt) => {
    setSlctedApnt(apnt);
    setAdmitModVsble(true);
  };

  const onCloseReSchReAss = () => {
    setReSchReAssModVsble(false);
    setSlctedApnt(null);
    setModErrs({});
    setAnchorEls({});
  };

  const handleSelectTime = (time) => {
    setSelectTime(time?.startTime);
    setModErrs({ ...modErrs, timeErr: "" });
  };

  const handleReschedule = () => {
    let errs = {};
    if (
      !slctedApnt?.reAssign &&
      !selectTime &&
      modValues?.appointmentOption !== "Immediate"
    ) {
      errs.timeErr = true;
    }
    if (!modValues?.appointmentOption)
      errs.appointmentOption = "This field is required";
    if (!(modValues?.vet?.doctorId ?? modValues?.vet?.value))
      errs.vet = "This field is required";
    if (Object.values(errs).some((err) => err?.length > 0 || err === true)) {
      return setModErrs(errs);
    }
    if (slctedApnt?.reAssign) {
      dispatch(showLoader());
      const data = {
        doctorId: modValues?.vet?.doctorId ?? modValues?.vet?.value,
      };
      if (modValues?.assignedUsers?.length > 0) {
        data.assignedUsers = modValues?.assignedUsers?.map((li) => li?.value);
      }
      // const form = new FormData();
      // form.append(
      //   "doctorId",
      //   modValues?.vet?.doctorId ?? modValues?.vet?.value
      // );
      dispatch(
        clinicReassignAppointment({
          appointmentId: slctedApnt?.appointmentId,
          data,
        })
      ).then((res) => {
        if (res?.payload) {
          handleApiCall();
          onCloseReSchReAss();
        }
      });
      dispatch(hideLoader());
    } else {
      dispatch(showLoader());
      const data = {
        appointmentDate: moment(new Date(modValues?.date)).format("YYYY-MM-DD"),
        doctorId: modValues?.vet?.doctorId ?? modValues?.vet?.value,
        appointmentStartTime: selectTime,
      };
      if (modValues?.assignedUsers?.length > 0) {
        data.assignedUsers = modValues?.assignedUsers;
      }
      data.appointmentEndTime = adjustTime(
        selectTime,
        getTimeDiffInMins(
          slctedApnt?.startTime ??
            slctedApnt?.appointmentTime ??
            slctedApnt?.appointmentStartTime,
          slctedApnt?.endTime ?? slctedApnt?.appointmentEndTime
        )?.totalMinutes ?? 0
        // getRequiredSlotList({
        //   availability: vetAvailability,
        //   date: modValues?.date,
        //   isDuration: true,
        // })
      );
      dispatch(
        clinicRescheduleAppointment({
          appointmentId: slctedApnt?.appointmentId,
          data,
        })
      ).then((res) => {
        if (res?.payload) {
          handleApiCall();
          onCloseReSchReAss();
        }
      });
      dispatch(hideLoader());
    }
  };

  const onFinalize = (apnt) => {
    dispatch(updateFinalize(apnt?.appointmentId)).then((res) => {
      if (res?.payload) {
        handleApiCall();
        setAnchorEls({});
      }
    });
  };

  const handleConsult = (
    apnt,
    vetId = null,
    facilityId = null,
    facilityName = null
  ) => {
    if (apnt?.appointmentType === "Home") {
      dispatch(
        updateAppointmentStatusById({
          appointmentId: apnt?.appointmentId,
          status: "consultation",
          successMsg: "Status updated successfully!",
        })
      ).then((res) => {
        if (res?.payload) {
          // if (role !== "ROLE_CLINIC" && profile?.id !== apnt?.doctorId) {
          //   const data = { doctorId: profile?.id };
          //   // const form = new FormData();
          //   // form.append("doctorId", profile?.id);
          //   dispatch(
          //     clinicReassignAppointment({
          //       appointmentId: apnt?.appointmentId,
          //       data,
          //     })
          //   );
          // }
          handleApiCall();
          setAnchorEls({});
        }
      });
    } else {
      if (
        // clinicDetails?.id === apnt?.doctorId &&
        // !checkIsVet(profile?.id) &&
        !vetId
      ) {
        const reqVet = !checkIsVet(apnt?.doctorId)
          ? null
          : clinicVets?.find((vl) => vl?.doctorId === apnt?.doctorId);
        setAssignVetValues({
          vet: !checkIsVet(apnt?.doctorId)
            ? null
            : {
                name: reqVet?.name ?? apnt?.doctorName,
                value: reqVet?.doctorId ?? apnt?.doctorId,
                id: reqVet?.doctorId ?? apnt?.doctorId,
              },
          facility: apnt?.facilityId
            ? {
                name: apnt?.facility ?? "",
                value: apnt?.facilityId,
                id: apnt?.facilityId,
              }
            : null,
        });
        setSlctedApnt(apnt);
        setAssignVetModVisible(true);
        return;
      }
      const data = {
        appointmentId: apnt?.appointmentId,
        doctorId: apnt?.doctorId,
      };
      dispatch(checkedCallInApi(data)).then((res) => {
        if (res?.payload) {
          // if (clinicDetails?.id === apnt?.doctorId) {
          const data = { facilityId, facilityName, doctorId: vetId };
          // if (!checkIsVet(apnt?.doctorId) && vetId) {
          //   data.doctorId = vetId;
          // } else if (checkIsVet(profile?.id)) {
          //   data.doctorId = profile?.id;
          // } else {
          //   handleApiCall();
          //   setAnchorEls({});
          //   return;
          // }
          dispatch(
            clinicReassignAppointment({
              appointmentId: apnt?.appointmentId,
              data,
            })
          ).then((reRes) => {
            if (reRes?.payload) {
              onCloseAssignVetMod();
              handleApiCall();
              setAnchorEls({});
              return;
            } else {
              onCloseAssignVetMod();
            }
          });
          // }
          // if (role !== "ROLE_CLINIC" && profile?.id !== apnt?.doctorId) {
          //   const data = { doctorId: profile?.id };
          //   // const form = new FormData();
          //   // form.append("doctorId", profile?.id);
          // dispatch(
          //   clinicReassignAppointment({
          //     appointmentId: apnt?.appointmentId,
          //     data,
          //   })
          // );
          // }
          handleApiCall();
          setAnchorEls({});
        }
      });
    }
  };

  const onCloseFlowMod = () => {
    setFlowModVsble(false);
    setSlctedApnt(null);
    setModValues({});
    setModErrs({});
    setAnchorEls({});
  };

  const onFollowUp = (apnt) => {
    setModValues({
      ...modValues,
      bookingType: "Phone",
      consultationMode: "Physical",
      serviceType: null,
      reason: "",
      vet: null,
      date: new Date(),
    });
    setSlctedApnt(apnt);
    setFlowModVsble(true);
  };

  const handleCheckout = (apnt) => {
    dispatch(updateCompleted(apnt?.appointmentId)).then((res) => {
      if (res?.payload) {
        if (
          profile?.createdBy === superTailsClinicId ||
          profile?.id === superTailsClinicId
        ) {
          dispatch(
            getMedicalHistoryByPetId({
              petId: apnt?.petId,
              url: `?type=all&page=1&itemSize=5`,
            })
          ).then((res2) => {
            if (res2?.payload?.data) {
              setSelectedHistory(res2?.payload?.data?.[0]);
              setPetData({
                petName: apnt?.petName,
                breed: apnt?.breed,
                gender: apnt?.gender,
                dob: apnt?.dob,
                userName: apnt?.userName,
                petData: apnt?.mobile,
              });
            }
          });
        }
        handleApiCall();
        setAnchorEls({});
      }
    });
  };

  const onOpenBookApnt = (vet) => {
    setModValues({
      ...modValues,
      bookingType: "Phone",
      consultationMode: "Physical",
      vet: {
        name: vet?.name,
        value: vet?.doctorId ?? vet?.value,
        doctorId: vet?.doctorId ?? vet?.value,
      },
      pet: null,
      date: new Date(),
    });
    setApntBookModVsble(true);
  };

  const onCloseBookMod = () => {
    setApntBookModVsble(false);
    setModValues({});
    setModErrs({});
  };

  const onChangeTableView = () => {
    if (!isTableView) onCalendarApiCall();
    setTableView(!isTableView);
    setAnchorEls({});
  };

  const onChangeApntStatus = (value) => {
    if (!value) return setSlctedApntStatus({ name: "All", value: "All" });
    setSlctedApntStatus(value);
  };

  const getMenuList = (apnt) => {
    const status = apnt?.appointmentStatus?.toLowerCase();
    const apntType = apnt?.appointmentType;
    switch (status) {
      case "scheduled": {
        return (
          <>
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => onCheckInTransit(apnt)}
            >
              {apntType === "Home" ? "In Transit" : "Check-in"}
            </Typography>
            <Divider />
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => handleCancel(apnt)}
            >
              Cancel
            </Typography>
            <Divider />
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => handleReschdule(apnt)}
            >
              Reschedule
            </Typography>
            {apntType === "Physical" && (
              <>
                <Divider />
                <Typography
                  className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
                  onClick={() => handleAdmit(apnt)}
                >
                  Admit
                </Typography>
              </>
            )}
          </>
        );
      }
      case "inprogress": {
        return (
          <>
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => handleReassign(apnt)}
            >
              Reassign
            </Typography>
            <Divider />
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => handleConsult(apnt)}
            >
              {apntType === "Physical" ? "Send to Consult" : "In Consult"}
            </Typography>
            {apntType === "Physical" && (
              <>
                <Divider />
                <Typography
                  className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
                  onClick={() => handleCancel(apnt)}
                >
                  Cancel
                </Typography>
                <Divider />
                <Typography
                  className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
                  onClick={() => handleAdmit(apnt)}
                >
                  Admit
                </Typography>
              </>
            )}
          </>
        );
      }
      case "intransit": {
        return (
          <>
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => handleReassign(apnt)}
            >
              Reassign
            </Typography>
            <Divider />
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => handleConsult(apnt)}
            >
              {apntType === "Physical" ? "Send to Consult" : "In Consult"}
            </Typography>
            {apntType === "Physical" && (
              <>
                <Divider />
                <Typography
                  className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
                  onClick={() => handleCancel(apnt)}
                >
                  Cancel
                </Typography>
                <Divider />
                <Typography
                  className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
                  onClick={() => handleAdmit(apnt)}
                >
                  Admit
                </Typography>
              </>
            )}
          </>
        );
      }
      case "consultation": {
        return (
          <>
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => onFinalize(apnt)}
            >
              Finalize
            </Typography>
            <Divider />
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => onFollowUp(apnt)}
            >
              Follow-up
            </Typography>
            {apntType === "Physical" && (
              <>
                <Divider />
                <Typography
                  className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
                  onClick={() => handleAdmit(apnt)}
                >
                  Admit
                </Typography>
              </>
            )}
          </>
        );
      }
      case "finalize": {
        return (
          <>
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => handleCheckout(apnt)}
            >
              Check-out
            </Typography>
            <Divider />
            <Typography
              className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
              onClick={() => onFollowUp(apnt)}
            >
              Follow-up
            </Typography>
          </>
        );
      }
      case "completed": {
        return (
          <Typography
            className="font-medium fs14 ph10 pv5 cursor txt-ali-left"
            onClick={() => onFollowUp(apnt)}
          >
            Follow-up
          </Typography>
        );
      }
    }
  };

  const handleUploadComplete = async (url, apntId) => {
    await api({ contentType: true, auth: true })
      .get(`/appointment/${apntId}`)
      .then(async (getRes) => {
        if (getRes?.status === 200 || getRes?.status === 201) {
          if (getRes?.data?.data) {
            const reqObj = {
              appointment: {
                ...getRes?.data?.data,
                // caseSummary: url
              },
            };
            try {
              // await superTailsApi.post("/appointment-completed", reqObj);
              setSelectedHistory(null);
              setPetData(null);
            } catch (supErr) {
              console.log("SuperTail Api Error", supErr);
            }
          }
        }
      });
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    };
    setSearchValues(reqObj);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = { ...initFilter, visible: true };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
    // if (filterValues?.selectedList?.length === 0) return;
    // onCalendarApiCall();
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onCalendarApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const getStatusListByConsultationType = (conType = []) => {
    if (!conType?.length || conType?.length === 0) return [];
    let reqList = [];
    if (conType?.some((li) => li?.value === "Physical")) {
      reqList = [...reqList, ...physicalStatusList];
    }
    if (conType?.some((li) => li?.value === "Virtual")) {
      reqList = [...reqList, ...virtualStatusList];
    }
    if (conType?.some((li) => li?.value === "Home")) {
      reqList = [...reqList, ...homeVisitStatusList];
    }
    const uniqueList =
      Array.from(
        new Map(reqList?.map((item) => [item?.value, item])).values()
      ) ?? [];
    return [
      { name: "All", value: "All" },
      ...(uniqueList ?? []),
      { name: "Cancelled", value: "Cancelled" },
    ];
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({ ...initFilter, selectedList: [], values: {} });
    });
    onCalendarApiCall(true);
  };

  const onCloseAssignVetMod = () => {
    setAssignVetModVisible(false);
    setAssignVetValues({});
    setSlctedApnt(null);
  };

  const getAllClinicUserListWoSelectedVet = (vetId) => {
    if (!vetId) return [];
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y" && vl?.doctorId !== vetId)
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const onAssignVetChange = (name, value, errName) => {
    setAssignVetValues({
      ...assignVetvalues,
      [name]: value,
      [errName]: value?.value ? false : true,
    });
  };

  const getFacilitiesByType = (type) => {
    const reqType =
      slctedApnt?.appointmentType === "Home"
        ? "HomeKit"
        : type === "Surgery"
        ? "OperationTheatre"
        : type === "Consultation" ||
          type === "Lab Tests" ||
          type === "Radiology Tests" ||
          type === "Others"
        ? "ConsultationRoom"
        : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => fl?.type === reqType)
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];

    return reqVetList;
  };

  const onAssignVet = () => {
    if (
      (clinicDetails?.id === slctedApnt?.doctorId &&
      !checkIsVet(slctedApnt?.doctorId) &&
      !checkIsVet(profile?.id)
        ? !assignVetvalues?.vet?.value
        : false) ||
      !assignVetvalues?.facility?.value
    ) {
      return setAssignVetValues({
        ...assignVetvalues,
        error:
          clinicDetails?.id === slctedApnt?.doctorId &&
          !checkIsVet(slctedApnt?.doctorId) &&
          !checkIsVet(profile?.id)
            ? !assignVetvalues?.vet?.value
            : false,
        facilityErr: !assignVetvalues?.facility?.value,
      });
    }
    if (slctedApnt?.appointmentType === "Physical") {
      handleConsult(
        slctedApnt,
        assignVetvalues?.vet?.value,
        assignVetvalues?.facility?.value,
        assignVetvalues?.facility?.name
      );
    } else {
      onCheckInTransit(
        slctedApnt,
        assignVetvalues?.vet?.value,
        assignVetvalues?.facility?.value,
        assignVetvalues?.facility?.name
      );
    }
  };

  return (
    <>
      {isTableView ? (
        <Grid container sx={{ padding: 0, alignItems: "center" }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Container maxWidth="xl">
              <Toolbar variant="regular">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row mt15">
                    <div className="top-row-cen-con w100Per">
                      {isTableView && (
                        <>
                          <div className="w15Per">
                            <CustomTextField
                              fullWidth
                              placeholder="Pet Name"
                              name="petName"
                              backgroundColor={AppColors.lightBlue2}
                              value={searchValues?.petName}
                              handleChange={onSearchChange}
                              label="Pet Name"
                            />
                          </div>
                          <div className="w15Per ml20">
                            <CustomSelect
                              list={vetDropList}
                              value={searchValues?.selectedVet}
                              handleChange={(e, value) =>
                                onSearchChange({
                                  target: { name: "selectedVet", value },
                                })
                              }
                              search
                              backgroundColor={AppColors.lightBlue2}
                            />
                          </div>
                          {/* <div className="w15Per ml20">
                            <CustomTextField
                              fullWidth
                              placeholder="Vet Name"
                              name="vetName"
                              backgroundColor={AppColors.lightBlue2}
                              value={searchValues?.vetName}
                              handleChange={onSearchChange}
                              label="Vet Name"
                            />
                          </div> */}
                          <div className="w15Per ml20">
                            <CustomSelect
                              list={typeList}
                              value={searchValues?.consultationType}
                              handleChange={onSearchChange}
                              name="consultationType"
                              label="Consultation Type"
                              multiSelectSearchCheck
                              backgroundColor={AppColors.lightBlue2}
                            />
                          </div>
                          <div className="w15Per ml20">
                            <CustomSelect
                              list={getStatusListByConsultationType(
                                searchValues?.consultationType
                              )}
                              value={searchValues?.status}
                              handleChange={onSearchChange}
                              name="status"
                              label="Status"
                              multiSelectSearchCheck
                              backgroundColor={AppColors.lightBlue2}
                            />
                          </div>
                          <div
                            className="flex-row-ali-cen ml20 filter cursor"
                            onClick={() => onFilterChange("visible", true)}
                          >
                            <TuneIcon sx={{ color: AppColors.appPrimary }} />
                            <Typography className="font-medium fs12 blue-color ml10">
                              {filterValues?.selectedList?.length > 0
                                ? `${filterValues?.selectedList?.length} `
                                : ""}
                              Filter
                            </Typography>
                          </div>
                          <div className="ml20">
                            <CustomButton
                              text="Reset"
                              onClick={onReset}
                              smallBtn
                              redBtn
                            />
                          </div>
                          <div
                          // className={`top-row-right-con ${
                          //   isTableView ? "w30Per" : "w20Per"
                          // } topBar-select`}
                          >
                            <div className="flex-row-ali-cen">
                              {/* {isTableView && (
                          <CustomSelect
                            list={appointmentStatusList}
                            value={slctedApntStatus}
                            handleChange={(e, value) =>
                              onChangeApntStatus(value)
                            }
                            search
                          />
                        )} */}
                              <div className="flex-row-ali-cen ph10">
                                <div
                                  className="cursor cal-tab-icon"
                                  onClick={onChangeTableView}
                                >
                                  <DashboardIcon
                                    sx={{
                                      height: 20,
                                      width: 20,
                                      color: isTableView
                                        ? AppColors.gray
                                        : AppColors.appPrimary,
                                    }}
                                  />
                                </div>
                                <div
                                  className="cursor cal-tab-icon"
                                  onClick={onChangeTableView}
                                >
                                  <TableRowsIcon
                                    sx={{
                                      height: 20,
                                      width: 20,
                                      color: isTableView
                                        ? AppColors.appPrimary
                                        : AppColors.gray,
                                    }}
                                  />
                                </div>
                              </div>
                              {/* <div style={{ width: 150 }}>
                                <CustomSelect
                                  list={vetDropList}
                                  value={selectedVet}
                                  handleChange={(e, value) =>
                                    handleChangeVet(value)
                                  }
                                  search
                                  backgroundColor={AppColors.lightBlue2}
                                />
                              </div> */}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <Typography className="font-medium fs12 gray28 mv10">
                    Number of Records: {appointmentsByFilter?.totalRecords ?? 0}
                  </Typography>
                </Grid>
              </Toolbar>
            </Container>
          </Grid>
        </Grid>
      ) : null}

      <Grid
        container
        spacing={0}
        className={`ph15 ${!isTableView ? "mt20" : ""}`}
      >
        {!isTableView && (
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <div className="scroll-70vh">
              <CustomTextField
                staticDate
                value={calDate}
                handleChange={onChangeCalDate}
              />
              <div className="back-white pv10 w99Per">
                <div className="flex-row-ali-cen jus-con-spa-even mh10 mtMin50">
                  <CustomCheckbox
                    label="Physical"
                    checked={conTypes?.includes("Physical")}
                    onChange={() => handleChangeCheckbox("Physical")}
                  />

                  <CustomCheckbox
                    label="Virtual"
                    checked={conTypes?.includes("Virtual")}
                    onChange={() => handleChangeCheckbox("Virtual")}
                  />

                  <CustomCheckbox
                    label="Home Visit"
                    checked={conTypes?.includes("Home")}
                    onChange={() => handleChangeCheckbox("Home")}
                  />
                </div>
                <Divider />
                <Typography className="font-bold fs14 text-align-center blue-color mv20">
                  Today’s Overview
                </Typography>
                {(selectedVet?.value === "all"
                  ? todayAppointments
                  : vetTodayAppointments
                )?.length > 0 ? (
                  (selectedVet?.value === "all"
                    ? todayAppointments
                    : vetTodayAppointments
                  )?.map((al) => (
                    <div className="flex-row mt10 ph10">
                      <div className="w10Per">
                        <div
                          className={`cal-dot ${
                            al?.appointmentStatus === "scheduled" ||
                            al?.appointmentStatus === "pending"
                              ? "card-top-orange-color"
                              : al?.appointmentStatus === "inprogress" ||
                                al?.appointmentStatus === "intransit"
                              ? "card-top-rose-color"
                              : al?.appointmentStatus === "consultation"
                              ? "card-top-green-color"
                              : al?.appointmentStatus === "finalize"
                              ? "card-top-yellow-color"
                              : al?.appointmentStatus === "completed"
                              ? "card-top-paleGreen-color"
                              : "card-con-red-back"
                          }`}
                        />
                      </div>
                      <div
                        className="w90Per cursor"
                        onClick={() => navDetailsPage(al)}
                      >
                        <div className="flex-row-ali-cen">
                          <Typography className="gray31 txt-semi-bold fs12 capitalize">
                            {al?.startTime ??
                              moment(al?.appointmentdateTime).format(
                                "HH:mm"
                              )}{" "}
                            – {al?.petName}
                          </Typography>
                          <div
                            className={`ml10 font-bold flex-center white-color fs10 ph10 pv5 br5 ${
                              al?.appointmentType === "Physical"
                                ? "card-con-blue-back"
                                : al?.appointmentType === "Virtual"
                                ? "virtual-bg-color"
                                : "card-con-gray-back"
                            }`}
                          >
                            {al?.appointmentType}
                          </div>
                        </div>
                        <div className="flex-row-ali-cen mt5">
                          <Typography className="font-medium fs10 card-black">
                            {al?.serviceType} |{" "}
                            {al?.doctorId === profile?.id ? "" : "Dr."}{" "}
                            {al?.doctorName} |{" "}
                            {getTypeByAppointmentType(al?.appointmentStatus)}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-rec">No records available</div>
                )}
              </div>
            </div>
          </Grid>
        )}
        {/* Right calendar section */}
        <Grid
          item
          xs={12}
          sm={12}
          md={isTableView ? 12 : 9}
          lg={isTableView ? 12 : 9}
          xl={isTableView ? 12 : 9}
        >
          {!isTableView ? (
            <div className="flex-row-between-align-center">
              <div className="flex-row-ali-cen mt10 scrollx">
                {[{ name: "All", value: "All" }, ...serviceTypes]?.map((sl) => (
                  <Typography
                    className={`gray4 fs14 ph10 pv5 br5 txt-semi-bold cursor mh5 ${
                      sleServiceTypes?.includes(sl?.name)
                        ? "green-back3"
                        : "gray-back2"
                    }`}
                    key={sl?.name}
                    onClick={() => handleServiceTypes(sl?.name)}
                  >
                    {sl?.name}
                  </Typography>
                ))}
              </div>
              <div className="flex-row-ali-cen">
                <div
                  className="cursor cal-tab-icon"
                  onClick={onChangeTableView}
                >
                  <DashboardIcon
                    sx={{
                      height: 20,
                      width: 20,
                      color: isTableView
                        ? AppColors.gray
                        : AppColors.appPrimary,
                    }}
                  />
                </div>
                <div
                  className="cursor cal-tab-icon"
                  onClick={onChangeTableView}
                >
                  <TableRowsIcon
                    sx={{
                      height: 20,
                      width: 20,
                      color: isTableView
                        ? AppColors.appPrimary
                        : AppColors.gray,
                    }}
                  />
                </div>

                <div style={{ width: 150 }} className="ml10">
                  <CustomSelect
                    list={vetDropList}
                    value={selectedVet}
                    handleChange={(e, value) => handleChangeVet(value)}
                    search
                    backgroundColor={AppColors.lightBlue2}
                  />
                </div>
              </div>
            </div>
          ) : null}
          <div className="back-white">
            <Grid container className="mv10 ph20">
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="p10"
              >
                {!isTableView ? (
                  <div className="flex-row">
                    <div className="flex1-center">
                      <div className="flex-row">
                        <div className="flex-center">
                          <NavigateBeforeOutlinedIcon
                            className="calendar-arrow cursor"
                            onClick={() =>
                              selectedType !== "week"
                                ? handleDateChange("minus")
                                : handleWeekChange("minus")
                            }
                          />
                          <Typography className="text-bold mh20">
                            {selectedType === "date"
                              ? moment(new Date(selectedDate)).format(
                                  "DD MMM YYYY"
                                )
                              : selectedType === "week" &&
                                `${moment(
                                  new Date(getWeekRange(weekDate)?.startDate)
                                ).format("DD MMM")} - ${moment(
                                  new Date(getWeekRange(weekDate)?.endDate)
                                ).format("DD YYYY")}`}
                          </Typography>
                          <NavigateNextOutlinedIcon
                            className="calendar-arrow cursor"
                            onClick={() =>
                              selectedType !== "week"
                                ? handleDateChange("add")
                                : handleWeekChange("add")
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex-end">
                      <Typography
                        className={`font-bold fs14 cursor day-type-box ${
                          selectedType === "date" ? "black" : "gray2"
                        }`}
                        onClick={handleSelectDay}
                      >
                        Day
                      </Typography>
                      <Typography
                        className={`font-bold fs14 cursor day-type-box ${
                          selectedType === "week" ? "black" : "gray2"
                        }`}
                        onClick={handleSelectWeek}
                      >
                        Week
                      </Typography>
                    </div>
                  </div>
                ) : null}
                {isTableView ? (
                  <TableContainer sx={{ maxHeight: 350 }}>
                    <Table
                      sx={{ minWidth: 200 }}
                      aria-labelledby="tableTitle"
                      stickyHeader
                    >
                      <TableHead>
                        <TableRow>
                          {tblHdrs?.map((hdr, i) => (
                            <TableCell
                              key={`${hdr}-${i}-tblVi`}
                              sortDirection={false}
                              // style={{
                              //   background: AppColors.tableGrey,
                              //   color: AppColors.white,
                              // }}
                              style={tblGrayBack}
                              className="txt-semi-bold fs12 capitalize"
                            >
                              {nameExpan?.[hdr]}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {getTableFilteredList()?.length === 0 && (
                          <TableRow>
                            <TableCell
                              colSpan={12}
                              className="text-align-center h100"
                            >
                              <div className="no-rec">No records available</div>
                            </TableCell>
                          </TableRow>
                        )}
                        {getTableFilteredList().map((li, ind) => (
                          <>
                            <TableRow
                              key={`${li?.appointmentId}-${ind}`}
                              style={{ position: "relative" }}
                            >
                              {tblHdrs?.map((hdr, ind) => (
                                <TableCell
                                  key={ind + `${ind}` + "tr"}
                                  component="th"
                                >
                                  {hdr === "petName" ? (
                                    <div onClick={() => navDetailsPage(li)}>
                                      <Custom3dotString
                                        str={li?.[hdr]}
                                        className="font-bold fs14 capitalize cursor blue-color underline"
                                      />
                                    </div>
                                  ) : hdr === "appointmentType" ? (
                                    <Typography className="font-medium fs14 black">
                                      {li?.[hdr] === "Home"
                                        ? "Home Visit"
                                        : li?.[hdr]}
                                    </Typography>
                                  ) : hdr === "vetName" ? (
                                    <Typography className="font-medium fs14 black">
                                      {li?.doctorName}
                                    </Typography>
                                  ) : hdr === "apntDate" ? (
                                    <Typography className="font-medium fs14 black">
                                      {moment(li?.appointmentdateTime).format(
                                        "DD MMM YYYY, HH:mm"
                                      )}
                                    </Typography>
                                  ) : hdr === "status" ? (
                                    <Typography
                                      className={`fs12 txt-regular white-color flex-center ph10 pv5 br5 ${
                                        li?.appointmentStatus?.toLowerCase() ===
                                          "canceled" ||
                                        li?.appointmentStatus?.toLowerCase() ===
                                          "cancelled"
                                          ? "card-con-red-back"
                                          : li?.appointmentStatus?.toLowerCase() ===
                                            "completed"
                                          ? "card-con-green-back"
                                          : li?.appointmentStatus?.toLowerCase() ===
                                              "consultation" ||
                                            li?.appointmentStatus?.toLowerCase() ===
                                              "finalize"
                                          ? "card-top-yellow-color"
                                          : "card-top-orange-color"
                                      }`}
                                    >
                                      {getTypeByAppointmentType(
                                        li?.appointmentStatus
                                      )}
                                    </Typography>
                                  ) : hdr === "action" ? (
                                    <div className="flex1-end">
                                      {li?.appointmentType !== "Virtual" &&
                                        li?.appointmentStatus?.toLowerCase() !==
                                          "pending" &&
                                        (li?.appointmentStatus?.toLowerCase() !==
                                          "canceled" ||
                                          li?.appointmentStatus?.toLowerCase() !==
                                            "cancelled") && (
                                          <MoreVertIcon
                                            sx={{
                                              height: 20,
                                              cursor: "pointer",
                                              transition: "color 0.3s ease",
                                              ":hover": {
                                                color: "#1976d2",
                                              },
                                            }}
                                            aria-controls={
                                              anchorEls?.[ind]
                                                ? "account-menu"
                                                : undefined
                                            }
                                            aria-haspopup="true"
                                            aria-expanded={
                                              anchorEls?.[ind]
                                                ? "true"
                                                : undefined
                                            }
                                            onClick={() => {
                                              anchorEls?.[li?.appointmentId]
                                                ? handleClose(li?.appointmentId)
                                                : handleClick(
                                                    li?.appointmentId
                                                  );
                                            }}
                                          />
                                        )}
                                    </div>
                                  ) : (
                                    <Typography className="font-medium fs14 black">
                                      {li?.[hdr]}
                                    </Typography>
                                  )}
                                </TableCell>
                              ))}
                              {anchorEls?.[li?.appointmentId] ? (
                                <div
                                  className="cal-menu"
                                  style={{
                                    left: window.innerWidth / 1.8 + 20,
                                    height: "auto",
                                    position: "absolute",
                                    top: 20,
                                  }}
                                >
                                  {getMenuList(li)}
                                </div>
                              ) : null}
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <div>
                    {selectedVet?.value === "all" && (
                      <TableContainer sx={{ maxHeight: 350 }}>
                        <Table
                          sx={{ minWidth: 200 }}
                          aria-labelledby="tableTitle"
                          stickyHeader
                        >
                          <TableHead>
                            <TableRow>
                              {[{}, ...(vetList ?? [])]?.map((vet, i) => (
                                <TableCell
                                  key={`vet-${i}-${vet?.value ?? ""}`}
                                  style={
                                    i === 0
                                      ? {
                                          backgroundColor: AppColors.white,
                                          color: AppColors.black,
                                          textAlign: "left",
                                          position: "sticky",
                                          left: 0,
                                          zIndex: 105,
                                          border: "1px solid #adb8cc",
                                          height: 70,
                                        }
                                      : {
                                          backgroundColor: AppColors.white,
                                          color: AppColors.black,
                                          textAlign: "center",
                                          border: "1px solid #adb8cc",
                                          height: 70,
                                        }
                                  }
                                  sortDirection={false}
                                  className={`table-header-text capitalize `}
                                >
                                  {i === 0 ? (
                                    <div style={{ width: 100 }}>
                                      {selectedType === "week" ? (
                                        <div className="flex-center">
                                          <CalendarMonthIcon className="gray2 w30h30" />
                                        </div>
                                      ) : (
                                        <div />
                                      )}
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        width:
                                          selectedType === "week" ? 200 : 200,
                                      }}
                                    >
                                      <Typography className="text-bold capitalize fs14">
                                        {`${
                                          vet?.id === profile?.id ? "" : "Dr. "
                                        } ${vet?.name}`}
                                      </Typography>
                                    </div>
                                  )}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {selectedType !== "week" &&
                              timeList?.length > 0 &&
                              timeList?.map((tl, i) => {
                                const currTime = moment().format("HH:mm");
                                const timeIsBet = isTimeBetween(currTime, tl);
                                return (
                                  <TableRow
                                    tabIndex={-1}
                                    ref={timeIsBet ? timeRef : null}
                                    key={`time-${i}-${tl}`}
                                  >
                                    <TableCell
                                      key={`time-${i}-${tl}-cell`}
                                      style={{
                                        backgroundColor: AppColors.white,
                                        color: AppColors.black,
                                        textAlign: "center",
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 100,
                                        paddingLeft: 20,
                                        height: 70,
                                        border: "1px solid #adb8cc",
                                      }}
                                    >
                                      <div style={{ width: 100 }}>
                                        {selectedType === "week" ? (
                                          <div className="flex-center">
                                            {tl}
                                          </div>
                                        ) : (
                                          <Typography
                                            className={`font-bold fs12 ${
                                              timeIsBet ? "red-color" : "gray6"
                                            }`}
                                          >
                                            {tl}
                                          </Typography>
                                        )}
                                      </div>
                                    </TableCell>
                                    {vetList?.length > 0 &&
                                      vetList?.map((vt, ind) => {
                                        const timeMatch =
                                          reqApnts?.[
                                            `${tl}-${tl?.split(":")?.[0]}:59`
                                          ];
                                        const matchRecors = timeMatch?.filter(
                                          (tma) =>
                                            tma?.doctorId === vt?.doctorId
                                        );
                                        const vetMatchRec =
                                          getFilteredList(matchRecors);
                                        return (
                                          <TableCell
                                            key={`vet-mat-${ind}-${vt?.value}`}
                                            style={{
                                              backgroundColor: AppColors.white,
                                              color: AppColors.black,
                                              textAlign: "center",
                                              border: "1px solid #adb8cc",
                                            }}
                                            className={
                                              vetMatchRec?.length > 0
                                                ? ""
                                                : "cursor"
                                            }
                                            onClick={() => {
                                              if (vetMatchRec?.length > 0)
                                                return;
                                              onOpenBookApnt(vt);
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: 220,
                                                height: "auto",
                                              }}
                                            >
                                              {vetMatchRec?.length > 0 && (
                                                <div className="appointment-box">
                                                  {vetMatchRec?.length > 0 &&
                                                    vetMatchRec?.map(
                                                      (timMa, index) => {
                                                        const apntStatus =
                                                          getTypeByAppointmentType(
                                                            timMa?.appointmentStatus
                                                          );
                                                        return (
                                                          <div
                                                            className={`cursor w100Per ${
                                                              index === 0
                                                                ? ""
                                                                : "mt15"
                                                            }`}
                                                            key={`appId-${timMa?.appointmentId}`}
                                                          >
                                                            <div
                                                              className={getClassNameForCalendar(
                                                                timMa?.serviceType
                                                              )}
                                                            >
                                                              <div className="flex-row">
                                                                <div
                                                                  className="w90Per"
                                                                  onClick={() =>
                                                                    navDetailsPage(
                                                                      timMa
                                                                    )
                                                                  }
                                                                >
                                                                  <div className="flex-column jus-con-spa-bet h50">
                                                                    <div className="flex-row">
                                                                      {timMa?.petImage ? (
                                                                        <img
                                                                          src={
                                                                            timMa?.petImage
                                                                          }
                                                                          alt=""
                                                                          className="pet-card-img2"
                                                                        />
                                                                      ) : (
                                                                        <div className="flex-center h20img">
                                                                          <Typography className="font-bold fs18 white-color capitalize">
                                                                            {
                                                                              timMa
                                                                                ?.petName?.[0]
                                                                            }
                                                                          </Typography>
                                                                        </div>
                                                                      )}
                                                                      <div
                                                                        className={`ml10 txt-regular flex-center white-color fs8 card-consultation ${
                                                                          timMa?.appointmentType ===
                                                                          "Physical"
                                                                            ? "card-con-blue-back"
                                                                            : timMa?.appointmentType ===
                                                                              "Virtual"
                                                                            ? "virtual-bg-color"
                                                                            : "card-con-gray-back"
                                                                        }`}
                                                                      >
                                                                        {
                                                                          timMa?.appointmentType
                                                                        }
                                                                      </div>
                                                                      <Typography
                                                                        className={`ml5 font-bold fs8 cal-time ${
                                                                          timMa?.serviceType ===
                                                                          "Vaccination"
                                                                            ? "green-back"
                                                                            : timMa?.serviceType ===
                                                                              "Consultation"
                                                                            ? "card-bot-blue-back"
                                                                            : timMa?.serviceType ===
                                                                              "Emergency"
                                                                            ? "card-bot-red-back"
                                                                            : "card-bot-rose-back"
                                                                        }`}
                                                                      >
                                                                        {timMa?.startTime ??
                                                                          moment(
                                                                            timMa?.appointmentdateTime
                                                                          ).format(
                                                                            "HH:mm"
                                                                          )}
                                                                      </Typography>
                                                                      <Typography
                                                                        className={`ml5 fs8 txt-regular white-color flex-center upcom-app-box ${
                                                                          timMa?.appointmentStatus?.toLowerCase() ===
                                                                            "canceled" ||
                                                                          timMa?.appointmentStatus?.toLowerCase() ===
                                                                            "cancelled"
                                                                            ? "card-con-red-back"
                                                                            : timMa?.appointmentStatus?.toLowerCase() ===
                                                                              "completed"
                                                                            ? "card-con-green-back"
                                                                            : timMa?.appointmentStatus?.toLowerCase() ===
                                                                                "consultation" ||
                                                                              timMa?.appointmentStatus?.toLowerCase() ===
                                                                                "finalize"
                                                                            ? "card-top-yellow-color"
                                                                            : "card-top-orange-color"
                                                                        }`}
                                                                      >
                                                                        {
                                                                          apntStatus
                                                                        }
                                                                      </Typography>
                                                                    </div>
                                                                    <div className="flex-row">
                                                                      <Typography className="font-bold fs10 capitalize">
                                                                        {`${
                                                                          timMa?.serviceType ??
                                                                          ""
                                                                        } | ${
                                                                          timMa?.petName
                                                                        }`}
                                                                      </Typography>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div className="w10Per">
                                                                  {timMa?.appointmentType !==
                                                                    "Virtual" &&
                                                                    timMa?.appointmentStatus?.toLowerCase() !==
                                                                      "pending" &&
                                                                    (timMa?.appointmentStatus?.toLowerCase() !==
                                                                      "canceled" ||
                                                                      timMa?.appointmentStatus?.toLowerCase() !==
                                                                        "cancelled") && (
                                                                      <MoreVertIcon
                                                                        sx={{
                                                                          height: 20,
                                                                          cursor:
                                                                            "pointer",
                                                                          transition:
                                                                            "color 0.3s ease",
                                                                          ":hover":
                                                                            {
                                                                              color:
                                                                                "#1976d2",
                                                                            },
                                                                        }}
                                                                        aria-controls={
                                                                          anchorEls?.[
                                                                            i
                                                                          ]
                                                                            ? "account-menu"
                                                                            : undefined
                                                                        }
                                                                        aria-haspopup="true"
                                                                        aria-expanded={
                                                                          anchorEls?.[
                                                                            i
                                                                          ]
                                                                            ? "true"
                                                                            : undefined
                                                                        }
                                                                        onClick={() => {
                                                                          anchorEls?.[
                                                                            timMa
                                                                              ?.appointmentId
                                                                          ]
                                                                            ? handleClose(
                                                                                timMa?.appointmentId
                                                                              )
                                                                            : handleClick(
                                                                                timMa?.appointmentId
                                                                              );
                                                                        }}
                                                                      />
                                                                    )}
                                                                </div>
                                                              </div>
                                                              {anchorEls?.[
                                                                timMa
                                                                  ?.appointmentId
                                                              ] ? (
                                                                <div
                                                                  className="cal-menu"
                                                                  style={{
                                                                    left: 210,
                                                                  }}
                                                                >
                                                                  {getMenuList(
                                                                    timMa
                                                                  )}
                                                                </div>
                                                              ) : null}
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                </div>
                                              )}
                                            </div>
                                          </TableCell>
                                        );
                                      })}
                                  </TableRow>
                                );
                              })}
                            {selectedType === "week" &&
                              dateList?.length > 0 &&
                              dateList?.map((dl, i) => {
                                return (
                                  <TableRow tabIndex={-1} key={i}>
                                    <TableCell
                                      key={`all-week-${dl}-${i}`}
                                      style={{
                                        backgroundColor: AppColors.white,
                                        color: AppColors.black,
                                        textAlign: "center",
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 100,
                                        paddingLeft: 20,
                                        height: 70,
                                        border: "1px solid #adb8cc",
                                      }}
                                    >
                                      <div style={{ width: 100 }}>
                                        <Typography className="font-bold fs12 gray6">
                                          {moment(dl).format("ddd DD")}
                                        </Typography>
                                      </div>
                                    </TableCell>
                                    {vetList?.length > 0 &&
                                      vetList?.map((vet, i) => {
                                        const matchRecors =
                                          appointmentLists?.filter(
                                            (ap) =>
                                              ap?.doctorId === vet?.doctorId &&
                                              ap?.appointmentDate ===
                                                (typeof dl === "string"
                                                  ? dl
                                                  : moment(new Date(dl)).format(
                                                      "YYYY-MM-DD"
                                                    ))
                                          );
                                        const dayData =
                                          getFilteredList(matchRecors);

                                        return (
                                          <TableCell
                                            key={`all-week-${
                                              vet?.value ?? ""
                                            }-${i}`}
                                            style={{
                                              backgroundColor: AppColors.white,
                                              color: AppColors.black,
                                              textAlign: "center",
                                              border: "1px solid #adb8cc",
                                            }}
                                            className={
                                              dayData?.length > 0
                                                ? ""
                                                : "cursor"
                                            }
                                            onClick={() => {
                                              if (dayData?.length > 0) return;
                                              onOpenBookApnt(vet);
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: 220,
                                                height: "auto",
                                              }}
                                            >
                                              {dayData?.length > 0 && (
                                                <div className="appointment-box">
                                                  <div
                                                    className={`flex-column`}
                                                  >
                                                    {dayData?.length > 0 &&
                                                      dayData?.map(
                                                        (timMa, index) => {
                                                          const apntStatus =
                                                            getTypeByAppointmentType(
                                                              timMa?.appointmentStatus
                                                            );
                                                          return (
                                                            <div
                                                              className={`cursor w100Per ${
                                                                index === 0
                                                                  ? ""
                                                                  : "mt15"
                                                              }`}
                                                              key={`all-week-${timMa?.appointmentId}-${index}`}
                                                            >
                                                              <div
                                                                className={getClassNameForCalendar(
                                                                  timMa?.serviceType
                                                                )}
                                                              >
                                                                <div className="flex-row">
                                                                  <div
                                                                    className="w90Per"
                                                                    onClick={() =>
                                                                      navDetailsPage(
                                                                        timMa
                                                                      )
                                                                    }
                                                                  >
                                                                    <div className="flex-column jus-con-spa-bet h50">
                                                                      <div className="flex-row">
                                                                        {timMa?.petImage ? (
                                                                          <img
                                                                            src={
                                                                              timMa?.petImage
                                                                            }
                                                                            alt=""
                                                                            className="pet-card-img2"
                                                                          />
                                                                        ) : (
                                                                          <div className="flex-center h20img">
                                                                            <Typography className="font-bold fs18 white-color capitalize">
                                                                              {
                                                                                timMa
                                                                                  ?.petName?.[0]
                                                                              }
                                                                            </Typography>
                                                                          </div>
                                                                        )}
                                                                        <div
                                                                          className={`ml10 txt-regular flex-center white-color fs8 card-consultation ${
                                                                            timMa?.appointmentType ===
                                                                            "Physical"
                                                                              ? "card-con-blue-back"
                                                                              : timMa?.appointmentType ===
                                                                                "Virtual"
                                                                              ? "virtual-bg-color"
                                                                              : "card-con-gray-back"
                                                                          }`}
                                                                        >
                                                                          {
                                                                            timMa?.appointmentType
                                                                          }
                                                                        </div>
                                                                        <Typography
                                                                          className={`ml5 font-bold fs8 cal-time ${
                                                                            timMa?.serviceType ===
                                                                            "Vaccination"
                                                                              ? "green-back"
                                                                              : timMa?.serviceType ===
                                                                                "Consultation"
                                                                              ? "card-bot-blue-back"
                                                                              : timMa?.serviceType ===
                                                                                "Emergency"
                                                                              ? "card-bot-red-back"
                                                                              : "card-bot-rose-back"
                                                                          }`}
                                                                        >
                                                                          {timMa?.startTime ??
                                                                            moment(
                                                                              timMa?.appointmentdateTime
                                                                            ).format(
                                                                              "HH:mm"
                                                                            )}
                                                                        </Typography>
                                                                        <Typography
                                                                          className={`ml5 fs8 txt-regular white-color flex-center upcom-app-box ${
                                                                            timMa?.appointmentStatus?.toLowerCase() ===
                                                                              "canceled" ||
                                                                            timMa?.appointmentStatus?.toLowerCase() ===
                                                                              "cancelled"
                                                                              ? "card-con-red-back"
                                                                              : timMa?.appointmentStatus?.toLowerCase() ===
                                                                                "completed"
                                                                              ? "card-con-green-back"
                                                                              : timMa?.appointmentStatus?.toLowerCase() ===
                                                                                  "consultation" ||
                                                                                timMa?.appointmentStatus?.toLowerCase() ===
                                                                                  "finalize"
                                                                              ? "card-top-yellow-color"
                                                                              : "card-top-orange-color"
                                                                          }`}
                                                                        >
                                                                          {
                                                                            apntStatus
                                                                          }
                                                                        </Typography>
                                                                      </div>
                                                                      <div className="flex-row">
                                                                        <Typography className="font-bold fs10 capitalize">
                                                                          {`${
                                                                            timMa?.serviceType ??
                                                                            ""
                                                                          } | ${
                                                                            timMa?.petName
                                                                          }`}
                                                                        </Typography>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="w10Per">
                                                                    {timMa?.appointmentType !==
                                                                      "Virtual" &&
                                                                      timMa?.appointmentStatus?.toLowerCase() !==
                                                                        "pending" &&
                                                                      (timMa?.appointmentStatus?.toLowerCase() !==
                                                                        "canceled" ||
                                                                        timMa?.appointmentStatus?.toLowerCase() !==
                                                                          "cancelled") && (
                                                                        <MoreVertIcon
                                                                          sx={{
                                                                            height: 20,
                                                                            cursor:
                                                                              "pointer",
                                                                            transition:
                                                                              "color 0.3s ease",
                                                                            ":hover":
                                                                              {
                                                                                color:
                                                                                  "#1976d2",
                                                                              },
                                                                          }}
                                                                          aria-controls={
                                                                            anchorEls?.[
                                                                              i
                                                                            ]
                                                                              ? "account-menu"
                                                                              : undefined
                                                                          }
                                                                          aria-haspopup="true"
                                                                          aria-expanded={
                                                                            anchorEls?.[
                                                                              i
                                                                            ]
                                                                              ? "true"
                                                                              : undefined
                                                                          }
                                                                          onClick={() => {
                                                                            anchorEls?.[
                                                                              timMa
                                                                                ?.appointmentId
                                                                            ]
                                                                              ? handleClose(
                                                                                  timMa?.appointmentId
                                                                                )
                                                                              : handleClick(
                                                                                  timMa?.appointmentId
                                                                                );
                                                                          }}
                                                                        />
                                                                      )}
                                                                  </div>
                                                                </div>
                                                                {anchorEls?.[
                                                                  timMa
                                                                    ?.appointmentId
                                                                ] ? (
                                                                  <div
                                                                    className="cal-menu"
                                                                    style={{
                                                                      left: 210,
                                                                    }}
                                                                  >
                                                                    {getMenuList(
                                                                      timMa
                                                                    )}
                                                                  </div>
                                                                ) : null}
                                                              </div>
                                                            </div>
                                                          );
                                                        }
                                                      )}
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </TableCell>
                                        );
                                      })}
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                    {selectedVet?.value !== "all" && (
                      <TableContainer sx={{ maxHeight: 350 }}>
                        <Table
                          sx={{ minWidth: 200 }}
                          aria-labelledby="tableTitle"
                          stickyHeader
                        >
                          <TableHead>
                            <TableRow>
                              {selectedType === "week" &&
                                [{}, ...dateList]?.map((dt, i) => (
                                  <TableCell
                                    key={`date-!all-${dt ?? ""}-${i}`}
                                    style={
                                      i === 0
                                        ? {
                                            backgroundColor: AppColors.white,
                                            color: AppColors.black,
                                            textAlign: "left",
                                            position: "sticky",
                                            left: 0,
                                            zIndex: 105,
                                            border: "1px solid #adb8cc",
                                            height: 70,
                                          }
                                        : {
                                            backgroundColor: AppColors.white,
                                            color: AppColors.black,
                                            textAlign: "center",
                                            border: "1px solid #adb8cc",
                                            height: 70,
                                          }
                                    }
                                    sortDirection={false}
                                    className={`table-header-text capitalize `}
                                  >
                                    {i === 0 ? (
                                      <div style={{ width: 100 }} />
                                    ) : (
                                      <div
                                        style={{
                                          width: 200,
                                        }}
                                      >
                                        <Typography className="text-bold capitalize fs14">
                                          {moment(dt).format("ddd DD")}
                                        </Typography>
                                      </div>
                                    )}
                                  </TableCell>
                                ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {timeList?.length > 0 &&
                              timeList?.map((tm, i) => {
                                const currTime = moment().format("HH:mm");
                                const timeIsBet = isTimeBetween(currTime, tm);
                                const timeMatch =
                                  reqApnts?.[`${tm}-${tm?.split(":")?.[0]}:59`];
                                const matchRecors = timeMatch?.filter(
                                  (tma) =>
                                    tma?.appointmentDate ===
                                    // selectedType === "today"
                                    // ? moment().format("YYYY-MM-DD")
                                    // :
                                    moment(new Date(selectedDate)).format(
                                      "YYYY-MM-DD"
                                    )
                                );
                                const dateMatchRec =
                                  getFilteredList(matchRecors);

                                return (
                                  <TableRow
                                    tabIndex={-1}
                                    ref={timeIsBet ? timeRef : null}
                                    key={`!all-time-${i}-${tm}`}
                                  >
                                    <TableCell
                                      key={`!all-time-${i}-${tm}-cell`}
                                      style={{
                                        backgroundColor: AppColors.white,
                                        color: AppColors.black,
                                        textAlign: "center",
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 100,
                                        paddingLeft: 20,
                                        height: 70,
                                        border: "1px solid #adb8cc",
                                      }}
                                    >
                                      <div style={{ width: 100 }}>
                                        <Typography
                                          className={`font-bold fs12 ${
                                            timeIsBet ? "red-color" : "gray6"
                                          }`}
                                        >
                                          {tm}
                                        </Typography>
                                      </div>
                                    </TableCell>
                                    {selectedType !== "week" && (
                                      <TableCell
                                        key={`!all-time-${i}-${tm}-!week`}
                                        style={{
                                          backgroundColor: AppColors.white,
                                          color: AppColors.black,
                                          textAlign: "center",
                                          height: 70,
                                          border: "1px solid #adb8cc",
                                        }}
                                        className={
                                          dateMatchRec?.length > 0
                                            ? ""
                                            : "cursor"
                                        }
                                        onClick={() => {
                                          if (dateMatchRec?.length > 0) return;
                                          onOpenBookApnt(selectedVet);
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: window.innerWidth / 1.77,
                                            height: "auto",
                                          }}
                                        >
                                          <div
                                            className={`flex-row ${
                                              dateMatchRec?.length > 1
                                                ? "jus-con-spa-bet"
                                                : ""
                                            }`}
                                          >
                                            {dateMatchRec?.length > 0
                                              ? dateMatchRec
                                                  ?.slice(0, 4)
                                                  ?.map((timMa, index) => {
                                                    const apntStatus =
                                                      getTypeByAppointmentType(
                                                        timMa?.appointmentStatus
                                                      );
                                                    return (
                                                      <div
                                                        className={`cursor  ${
                                                          dateMatchRec?.length ===
                                                          1
                                                            ? "w100Per"
                                                            : dateMatchRec?.length ===
                                                              2
                                                            ? "w49Per"
                                                            : dateMatchRec?.length ===
                                                              3
                                                            ? "w32Per"
                                                            : "w23Per"
                                                        }`}
                                                        key={`tim-mat-${index}-${timMa?.appointmentId}`}
                                                      >
                                                        <div
                                                          className={getClassNameForCalendar(
                                                            timMa?.serviceType
                                                          )}
                                                        >
                                                          <div className="flex-row">
                                                            <div
                                                              className="w90Per"
                                                              onClick={() =>
                                                                navDetailsPage(
                                                                  timMa
                                                                )
                                                              }
                                                            >
                                                              <div className="flex-column jus-con-spa-bet h50">
                                                                <div className="flex-row">
                                                                  {timMa?.petImage ? (
                                                                    <img
                                                                      src={
                                                                        timMa?.petImage
                                                                      }
                                                                      alt=""
                                                                      className="pet-card-img2"
                                                                    />
                                                                  ) : (
                                                                    <div className="flex-center h20img">
                                                                      <Typography className="font-bold fs18 white-color capitalize">
                                                                        {
                                                                          timMa
                                                                            ?.petName?.[0]
                                                                        }
                                                                      </Typography>
                                                                    </div>
                                                                  )}
                                                                  <div
                                                                    className={`ml10 txt-regular white-color flex-center fs8 card-consultation ${
                                                                      timMa?.appointmentType ===
                                                                      "Physical"
                                                                        ? "card-con-blue-back"
                                                                        : timMa?.appointmentType ===
                                                                          "Virtual"
                                                                        ? "virtual-bg-color"
                                                                        : "card-con-gray-back"
                                                                    }`}
                                                                  >
                                                                    {
                                                                      timMa?.appointmentType
                                                                    }
                                                                  </div>
                                                                  <Typography
                                                                    className={`ml5 font-bold fs8 cal-time ${
                                                                      timMa?.appointmentType ===
                                                                      "Physical"
                                                                        ? "card-con-blue-back"
                                                                        : timMa?.appointmentType ===
                                                                          "Virtual"
                                                                        ? "virtual-bg-color"
                                                                        : "card-con-gray-back"
                                                                    }`}
                                                                  >
                                                                    {timMa?.startTime ??
                                                                      moment(
                                                                        timMa?.appointmentdateTime
                                                                      ).format(
                                                                        "HH:mm"
                                                                      )}
                                                                  </Typography>
                                                                  <Typography
                                                                    className={`ml5 fs8 txt-regular white-color flex-center upcom-app-box ${
                                                                      timMa?.appointmentStatus?.toLowerCase() ===
                                                                        "canceled" ||
                                                                      timMa?.appointmentStatus?.toLowerCase() ===
                                                                        "cancelled"
                                                                        ? "card-con-red-back"
                                                                        : timMa?.appointmentStatus?.toLowerCase() ===
                                                                          "completed"
                                                                        ? "card-con-green-back"
                                                                        : timMa?.appointmentStatus?.toLowerCase() ===
                                                                            "consultation" ||
                                                                          timMa?.appointmentStatus?.toLowerCase() ===
                                                                            "finalize"
                                                                        ? "card-top-yellow-color"
                                                                        : "card-top-orange-color"
                                                                    }`}
                                                                  >
                                                                    {apntStatus}
                                                                  </Typography>
                                                                </div>
                                                                <div className="flex-row">
                                                                  <Typography className="font-bold fs10 capitalize">
                                                                    {`${
                                                                      timMa?.serviceType ??
                                                                      ""
                                                                    } | ${
                                                                      timMa?.petName
                                                                    }`}
                                                                  </Typography>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="w10Per">
                                                              {timMa?.appointmentType !==
                                                                "Virtual" &&
                                                                timMa?.appointmentStatus?.toLowerCase() !==
                                                                  "pending" &&
                                                                (timMa?.appointmentStatus?.toLowerCase() !==
                                                                  "canceled" ||
                                                                  timMa?.appointmentStatus?.toLowerCase() !==
                                                                    "cancelled") && (
                                                                  <MoreVertIcon
                                                                    sx={{
                                                                      height: 20,
                                                                      cursor:
                                                                        "pointer",
                                                                      transition:
                                                                        "color 0.3s ease",
                                                                      ":hover":
                                                                        {
                                                                          color:
                                                                            "#1976d2",
                                                                        },
                                                                    }}
                                                                    aria-controls={
                                                                      anchorEls?.[
                                                                        i
                                                                      ]
                                                                        ? "account-menu"
                                                                        : undefined
                                                                    }
                                                                    aria-haspopup="true"
                                                                    aria-expanded={
                                                                      anchorEls?.[
                                                                        i
                                                                      ]
                                                                        ? "true"
                                                                        : undefined
                                                                    }
                                                                    onClick={() => {
                                                                      anchorEls?.[
                                                                        timMa
                                                                          ?.appointmentId
                                                                      ]
                                                                        ? handleClose(
                                                                            timMa?.appointmentId
                                                                          )
                                                                        : handleClick(
                                                                            timMa?.appointmentId
                                                                          );
                                                                    }}
                                                                  />
                                                                )}
                                                            </div>
                                                          </div>
                                                          {anchorEls?.[
                                                            timMa?.appointmentId
                                                          ] ? (
                                                            <div
                                                              className="cal-menu"
                                                              style={{
                                                                width: 200,
                                                                left:
                                                                  dateMatchRec?.length ===
                                                                  1
                                                                    ? window.innerWidth /
                                                                      2.6
                                                                    : dateMatchRec?.length ===
                                                                      2
                                                                    ? window.innerWidth /
                                                                      9
                                                                    : dateMatchRec?.length ===
                                                                      3
                                                                    ? window.innerWidth /
                                                                      55
                                                                    : -40,
                                                              }}
                                                            >
                                                              {getMenuList(
                                                                timMa
                                                              )}
                                                            </div>
                                                          ) : null}
                                                        </div>
                                                      </div>
                                                    );
                                                  })
                                              : null}
                                          </div>
                                          {dateMatchRec?.length > 4 && (
                                            <div
                                              className={`flex-row mt15 ${
                                                dateMatchRec?.length > 4
                                                  ? "jus-con-spa-bet"
                                                  : ""
                                              }`}
                                            >
                                              {dateMatchRec
                                                ?.slice(4, 8)
                                                ?.map((timMa, index) => {
                                                  const apntStatus =
                                                    getTypeByAppointmentType(
                                                      timMa?.appointmentStatus
                                                    );
                                                  return (
                                                    <div
                                                      className={`cursor  ${
                                                        dateMatchRec?.slice(
                                                          4,
                                                          8
                                                        )?.length === 1
                                                          ? "w100Per"
                                                          : dateMatchRec?.slice(
                                                              4,
                                                              8
                                                            )?.length === 2
                                                          ? "w49Per"
                                                          : dateMatchRec?.slice(
                                                              4,
                                                              8
                                                            )?.length === 3
                                                          ? "w32Per"
                                                          : "w23Per"
                                                      }`}
                                                      key={`tim-mat-${
                                                        index + 4
                                                      }-${
                                                        timMa?.appointmentId
                                                      }`}
                                                    >
                                                      <div
                                                        className={getClassNameForCalendar(
                                                          timMa?.serviceType
                                                        )}
                                                      >
                                                        <div className="flex-row">
                                                          <div
                                                            className="w90Per"
                                                            onClick={() =>
                                                              navDetailsPage(
                                                                timMa
                                                              )
                                                            }
                                                          >
                                                            <div className="flex-column jus-con-spa-bet h50">
                                                              <div className="flex-row">
                                                                {timMa?.petImage ? (
                                                                  <img
                                                                    src={
                                                                      timMa?.petImage
                                                                    }
                                                                    alt=""
                                                                    className="pet-card-img2"
                                                                  />
                                                                ) : (
                                                                  <div className="flex-center h20img">
                                                                    <Typography className="font-bold fs18 white-color capitalize">
                                                                      {
                                                                        timMa
                                                                          ?.petName?.[0]
                                                                      }
                                                                    </Typography>
                                                                  </div>
                                                                )}
                                                                <div
                                                                  className={`ml10 txt-regular white-color flex-center fs8 card-consultation ${
                                                                    timMa?.appointmentType ===
                                                                    "Physical"
                                                                      ? "card-con-blue-back"
                                                                      : timMa?.appointmentType ===
                                                                        "Virtual"
                                                                      ? "virtual-bg-color"
                                                                      : "card-con-gray-back"
                                                                  }`}
                                                                >
                                                                  {
                                                                    timMa?.appointmentType
                                                                  }
                                                                </div>
                                                                <Typography
                                                                  className={`ml5 font-bold fs8 cal-time ${
                                                                    timMa?.appointmentType ===
                                                                    "Physical"
                                                                      ? "card-con-blue-back"
                                                                      : timMa?.appointmentType ===
                                                                        "Virtual"
                                                                      ? "virtual-bg-color"
                                                                      : "card-con-gray-back"
                                                                  }`}
                                                                >
                                                                  {timMa?.startTime ??
                                                                    moment(
                                                                      timMa?.appointmentdateTime
                                                                    ).format(
                                                                      "HH:mm"
                                                                    )}
                                                                </Typography>
                                                                <Typography
                                                                  className={`ml5 fs8 txt-regular white-color flex-center upcom-app-box ${
                                                                    timMa?.appointmentStatus?.toLowerCase() ===
                                                                      "canceled" ||
                                                                    timMa?.appointmentStatus?.toLowerCase() ===
                                                                      "cancelled"
                                                                      ? "card-con-red-back"
                                                                      : timMa?.appointmentStatus?.toLowerCase() ===
                                                                        "completed"
                                                                      ? "card-con-green-back"
                                                                      : timMa?.appointmentStatus?.toLowerCase() ===
                                                                          "consultation" ||
                                                                        timMa?.appointmentStatus?.toLowerCase() ===
                                                                          "finalize"
                                                                      ? "card-top-yellow-color"
                                                                      : "card-top-orange-color"
                                                                  }`}
                                                                >
                                                                  {apntStatus}
                                                                </Typography>
                                                              </div>
                                                              <div className="flex-row">
                                                                <Typography className="font-bold fs10 capitalize">
                                                                  {`${
                                                                    timMa?.serviceType ??
                                                                    ""
                                                                  } | ${
                                                                    timMa?.petName
                                                                  }`}
                                                                </Typography>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="w10Per">
                                                            {timMa?.appointmentType !==
                                                              "Virtual" &&
                                                              timMa?.appointmentStatus?.toLowerCase() !==
                                                                "pending" &&
                                                              (timMa?.appointmentStatus?.toLowerCase() !==
                                                                "canceled" ||
                                                                timMa?.appointmentStatus?.toLowerCase() !==
                                                                  "cancelled") && (
                                                                <MoreVertIcon
                                                                  sx={{
                                                                    height: 20,
                                                                    cursor:
                                                                      "pointer",
                                                                    transition:
                                                                      "color 0.3s ease",
                                                                    ":hover": {
                                                                      color:
                                                                        "#1976d2",
                                                                    },
                                                                  }}
                                                                  aria-controls={
                                                                    anchorEls?.[
                                                                      i
                                                                    ]
                                                                      ? "account-menu"
                                                                      : undefined
                                                                  }
                                                                  aria-haspopup="true"
                                                                  aria-expanded={
                                                                    anchorEls?.[
                                                                      i
                                                                    ]
                                                                      ? "true"
                                                                      : undefined
                                                                  }
                                                                  onClick={() => {
                                                                    anchorEls?.[
                                                                      timMa
                                                                        ?.appointmentId
                                                                    ]
                                                                      ? handleClose(
                                                                          timMa?.appointmentId
                                                                        )
                                                                      : handleClick(
                                                                          timMa?.appointmentId
                                                                        );
                                                                  }}
                                                                />
                                                              )}
                                                          </div>
                                                        </div>
                                                        {anchorEls?.[
                                                          timMa?.appointmentId
                                                        ] ? (
                                                          <div className="cal-menu">
                                                            {getMenuList(timMa)}
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          )}
                                        </div>
                                      </TableCell>
                                    )}
                                    {selectedType === "week" &&
                                      dateList?.length > 0 &&
                                      dateList?.map((dt, i) => {
                                        const timeMatch =
                                          reqApnts?.[
                                            `${tm}-${tm?.split(":")?.[0]}:59`
                                          ];
                                        const matchRecors = timeMatch?.filter(
                                          (rl) =>
                                            rl?.appointmentDate ===
                                            (typeof dt === "string"
                                              ? dt
                                              : moment(new Date(dt)).format(
                                                  "YYYY-MM-DD"
                                                ))
                                        );
                                        const reqList =
                                          getFilteredList(matchRecors);

                                        return (
                                          <TableCell
                                            key={`week-!all-${dt}-${i}`}
                                            style={{
                                              backgroundColor: AppColors.white,
                                              color: AppColors.black,
                                              textAlign: "center",
                                              height: 70,
                                              border: "1px solid #adb8cc",
                                            }}
                                            className={
                                              reqList?.length > 0
                                                ? ""
                                                : "cursor"
                                            }
                                            onClick={() => {
                                              if (reqList?.length > 0) return;
                                              onOpenBookApnt(selectedVet);
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: 220,
                                                height: "auto",
                                              }}
                                            >
                                              <div className="flex-column">
                                                {reqList?.length > 0
                                                  ? reqList?.map(
                                                      (timMa, index) => {
                                                        const apntStatus =
                                                          getTypeByAppointmentType(
                                                            timMa?.appointmentStatus
                                                          );
                                                        return (
                                                          <div
                                                            className={`cursor w100Per ${
                                                              index === 0
                                                                ? ""
                                                                : "mt15"
                                                            }`}
                                                            key={`week-!all-tim-${timMa?.appointmentId}-${index}`}
                                                          >
                                                            <div
                                                              className={getClassNameForCalendar(
                                                                timMa?.serviceType
                                                              )}
                                                            >
                                                              <div className="flex-row">
                                                                <div
                                                                  className="w90Per"
                                                                  onClick={() =>
                                                                    navDetailsPage(
                                                                      timMa
                                                                    )
                                                                  }
                                                                >
                                                                  <div className="flex-column jus-con-spa-bet h50">
                                                                    <div className="flex-row">
                                                                      {timMa?.petImage ? (
                                                                        <img
                                                                          src={
                                                                            timMa?.petImage
                                                                          }
                                                                          alt=""
                                                                          className="pet-card-img2"
                                                                        />
                                                                      ) : (
                                                                        <div className="flex-center h20img">
                                                                          <Typography className="font-bold fs18 white-color capitalize">
                                                                            {
                                                                              timMa
                                                                                ?.petName?.[0]
                                                                            }
                                                                          </Typography>
                                                                        </div>
                                                                      )}
                                                                      <div
                                                                        className={`ml10 txt-regular white-color flex-center fs8 card-consultation ${
                                                                          timMa?.appointmentType ===
                                                                          "Physical"
                                                                            ? "card-con-blue-back"
                                                                            : timMa?.appointmentType ===
                                                                              "Virtual"
                                                                            ? "virtual-bg-color"
                                                                            : "card-con-gray-back"
                                                                        }`}
                                                                      >
                                                                        {
                                                                          timMa?.appointmentType
                                                                        }
                                                                      </div>
                                                                      <Typography
                                                                        className={`ml5 font-bold fs8 cal-time ${
                                                                          timMa?.appointmentType ===
                                                                          "Physical"
                                                                            ? "card-con-blue-back"
                                                                            : timMa?.appointmentType ===
                                                                              "Virtual"
                                                                            ? "virtual-bg-color"
                                                                            : "card-con-gray-back"
                                                                        }`}
                                                                      >
                                                                        {timMa?.startTime ??
                                                                          moment(
                                                                            timMa?.appointmentdateTime
                                                                          ).format(
                                                                            "HH:mm"
                                                                          )}
                                                                      </Typography>
                                                                      <Typography
                                                                        className={`ml5 fs8 txt-regular white-color flex-center upcom-app-box ${
                                                                          timMa?.appointmentStatus?.toLowerCase() ===
                                                                            "canceled" ||
                                                                          timMa?.appointmentStatus?.toLowerCase() ===
                                                                            "cancelled"
                                                                            ? "card-con-red-back"
                                                                            : timMa?.appointmentStatus?.toLowerCase() ===
                                                                              "completed"
                                                                            ? "card-con-green-back"
                                                                            : timMa?.appointmentStatus?.toLowerCase() ===
                                                                                "consultation" ||
                                                                              timMa?.appointmentStatus?.toLowerCase() ===
                                                                                "finalize"
                                                                            ? "card-top-yellow-color"
                                                                            : "card-top-orange-color"
                                                                        }`}
                                                                      >
                                                                        {
                                                                          apntStatus
                                                                        }
                                                                      </Typography>
                                                                    </div>
                                                                    <div className="flex-row">
                                                                      <Typography className="font-bold fs10 capitalize">
                                                                        {`${
                                                                          timMa?.serviceType ??
                                                                          ""
                                                                        } | ${
                                                                          timMa?.petName
                                                                        }`}
                                                                      </Typography>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div className="w10Per">
                                                                  {timMa?.appointmentType !==
                                                                    "Virtual" &&
                                                                    timMa?.appointmentStatus?.toLowerCase() !==
                                                                      "pending" &&
                                                                    (timMa?.appointmentStatus?.toLowerCase() !==
                                                                      "canceled" ||
                                                                      timMa?.appointmentStatus?.toLowerCase() !==
                                                                        "cancelled") && (
                                                                      <MoreVertIcon
                                                                        sx={{
                                                                          height: 20,
                                                                          cursor:
                                                                            "pointer",
                                                                          transition:
                                                                            "color 0.3s ease",
                                                                          ":hover":
                                                                            {
                                                                              color:
                                                                                "#1976d2",
                                                                            },
                                                                        }}
                                                                        aria-controls={
                                                                          anchorEls?.[
                                                                            i
                                                                          ]
                                                                            ? "account-menu"
                                                                            : undefined
                                                                        }
                                                                        aria-haspopup="true"
                                                                        aria-expanded={
                                                                          anchorEls?.[
                                                                            i
                                                                          ]
                                                                            ? "true"
                                                                            : undefined
                                                                        }
                                                                        onClick={() => {
                                                                          anchorEls?.[
                                                                            timMa
                                                                              ?.appointmentId
                                                                          ]
                                                                            ? handleClose(
                                                                                timMa?.appointmentId
                                                                              )
                                                                            : handleClick(
                                                                                timMa?.appointmentId
                                                                              );
                                                                        }}
                                                                      />
                                                                    )}
                                                                </div>
                                                              </div>
                                                              {anchorEls?.[
                                                                timMa
                                                                  ?.appointmentId
                                                              ] ? (
                                                                <div
                                                                  className="cal-menu"
                                                                  style={{
                                                                    left: 210,
                                                                  }}
                                                                >
                                                                  {getMenuList(
                                                                    timMa
                                                                  )}
                                                                </div>
                                                              ) : null}
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    )
                                                  : null}
                                              </div>
                                            </div>
                                          </TableCell>
                                        );
                                      })}
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>

      {selectedHistory ? (
        <MedicalHistoryView
          selectedHistory={selectedHistory}
          petData={petData}
          onUploadComplete={(e, apntId) => handleUploadComplete(e, apntId)}
        />
      ) : null}

      {flowModVsble ? (
        <BookAnAppointment
          modalVisible={flowModVsble}
          setBookModVisible={onCloseFlowMod}
          selectedPet={{
            petId: slctedApnt?.petId,
            petName: slctedApnt?.petName,
            petImage: slctedApnt?.petImage,
            gender: slctedApnt?.gender,
            breed: slctedApnt?.breed,
            dob: slctedApnt?.dob,
            userName: slctedApnt?.userName,
            color: slctedApnt?.color,
            weight: slctedApnt?.weight,
            userMobile: slctedApnt?.userMobile,
            mobile: slctedApnt?.mobile,
          }}
          prevAppointmentId={slctedApnt?.appointmentId}
        />
      ) : null}

      {apntBookModVsble ? (
        <VetBookAnAppointment
          modalVisible={apntBookModVsble}
          setBookModVisible={onCloseBookMod}
          selectedVet={{
            doctorId: modValues?.vet?.doctorId ?? modValues?.vet?.value,
            name: modValues?.vet?.name,
          }}
        />
      ) : null}

      <CustomModal
        open={canModVsble}
        onClose={onCloseCancelMod}
        header="Cancel"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to cancel the appointment?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton text="Yes" redBtn onClick={conCancel} smallBtn />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseCancelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={admitModVsble}
        onClose={onCloseAdmitMod}
        header="Admit Patient"
        rightModal
        modalWidth={30}
        headerBold
      >
        <Grid container spacing={1} className="ph20">
          <Grid item xs={12}>
            <Card sx={cardSty} className="CustomCard-back-appointment">
              <div className="maint">
                <div className="flex-row">
                  <Grid item xs={3}>
                    <div className="flex-center">
                      {slctedApnt?.petImage ? (
                        <CardMedia
                          image={slctedApnt?.petImage}
                          className="CustomCard-img3-bill"
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {slctedApnt?.petName?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Grid>
                  <div className="flex-row">
                    <div className="flex-start">
                      <div className="flex-column">
                        <div className="flex-row">
                          <div className="mb10 txt-semi-bold black fs14 capitalize">
                            {slctedApnt?.petName}
                          </div>
                          {slctedApnt?.gender?.length > 0 ? (
                            <Typography
                              className={`ml5 text capitalize ${
                                slctedApnt?.gender === "male"
                                  ? "card-blue-color"
                                  : "card-rose-color"
                              }`}
                            >
                              {`(${slctedApnt?.gender})`}
                            </Typography>
                          ) : null}
                        </div>
                        <Typography className="mb10 txt-regular card-gray-color fs12">
                          {slctedApnt?.breed}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex-row parentcontainer mt10">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <div className="txt-semi-bold fs14 capitalize">
                        {slctedApnt?.userName}
                      </div>
                    </div>
                    <div className="meeting-doctor">
                      {moment(slctedApnt?.appointmentDate).fromNow()} (
                      {slctedApnt?.appointmentDate})
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="mb20">
              <CustomTextField
                name="kennelNumber"
                value={modValues?.kennelNumber}
                label="Kennel Number "
                fullWidth
                handleChange={(e) =>
                  handleModValueChange("kennelNumber", e?.target?.value)
                }
                error={!!modErrs?.kennelNumber}
                helperText={modErrs?.kennelNumber}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="mb20">
              <CustomTextField
                fullWidth
                multiline
                rows={3}
                handleChange={(e) =>
                  handleModValueChange("remark", e?.target?.value)
                }
                label="Reason"
                required={true}
                value={modValues?.remark ?? ""}
                error={!!modErrs?.remark}
                helperText={modErrs?.remark}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="mb20">
              <CustomSelect
                list={vetDropList?.filter((li) => li?.value !== "all")}
                handleChange={(e, value) => handleModValueChange("vet", value)}
                name="vet"
                label="Vet Name *"
                search
                value={modValues?.vet}
                error={!!modErrs?.vet}
                helperText={modErrs?.vet}
              />
            </div>
          </Grid>
        </Grid>
        <div className="flex1-end mt20">
          <div>
            <CustomButton text="Save" onClick={handleAdmitPatient} smallBtn />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={reSchReAssModVsble}
        onClose={onCloseReSchReAss}
        header="Reschedule / Reassign"
        rightModal
        modalWidth={30}
        headerBold
      >
        <Grid container spacing={1} className="ph20 scroll-80vh">
          <Grid item xs={12}>
            <Card sx={cardSty} className="CustomCard-back-appointment">
              <div className="maint">
                <div className="flex-row">
                  <Grid item xs={3}>
                    <div className="flex-center">
                      {slctedApnt?.petImage ? (
                        <CardMedia
                          image={slctedApnt?.petImage}
                          className="CustomCard-img3-bill"
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {slctedApnt?.petName?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Grid>
                  <div className="flex-row">
                    <div className="flex-start">
                      <div className="flex-column">
                        <div className="flex-row">
                          <div className="mb10 txt-semi-bold black fs14 capitalize">
                            {slctedApnt?.petName}
                          </div>
                          {slctedApnt?.gender?.length > 0 ? (
                            <Typography
                              className={`ml5 text capitalize ${
                                slctedApnt?.gender === "male"
                                  ? "card-blue-color"
                                  : "card-rose-color"
                              }`}
                            >
                              {`(${slctedApnt?.gender})`}
                            </Typography>
                          ) : null}
                        </div>
                        <Typography className="mb10 txt-regular card-gray-color fs12">
                          {slctedApnt?.breed}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex-row parentcontainer mt10">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <div className="txt-semi-bold fs14 capitalize">
                        {slctedApnt?.userName}
                      </div>
                    </div>
                    <div className="meeting-doctor">
                      {moment(slctedApnt?.appointmentDate).fromNow()} (
                      {slctedApnt?.appointmentDate})
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="txt-semi-bold fs14 light-grey">
              Booking Type <span className="red-color">*</span>
            </div>
            <CustomSelect
              value={slctedApnt?.bookingType ?? "Walk In"}
              selectFixed
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="txt-semi-bold fs14 light-grey">
              Consultation Mode <span className="red-color">*</span>
            </div>
            <CustomSelect value={slctedApnt?.appointmentType} selectFixed />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Service Type <span className="red-color">*</span>
            </div>
            <CustomSelect value={slctedApnt?.serviceType} selectFixed />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Reason for visit <span className="red-color">*</span>
            </div>
            <CustomSelect value={slctedApnt?.reason} selectFixed />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomSelect
              list={vetDropList?.filter((li) => li?.value !== "all")}
              handleChange={(e, value) => handleModValueChange("vet", value)}
              name="vet"
              search
              value={modValues?.vet}
              error={!!modErrs?.vet}
              helperText={modErrs?.vet}
              label="Vet Name *"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey mb10">
              Assigned Users
            </div>
            <CustomSelect
              list={getAllClinicUserListWoSelectedVet(modValues?.vet?.value)}
              value={modValues?.assignedUsers ?? []}
              name="assignedUsers"
              handleChange={(e) => {
                handleModValueChange("assignedUsers", e?.target?.value);
              }}
              multiSelectTagCheck
              // backgroundColor={AppColors.lightBlue2}
              multiSelectSearchCheck
            />
          </Grid>
          {slctedApnt?.reAssign ? null : (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Appointment Time:{" "}
                {moment(new Date(slctedApnt?.appointmentdateTime)).format(
                  "DD MMM YYYY HH:mm"
                )}
              </div>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="mbminus"
          >
            <div className="flex-row">
              <div className="txt-semi-bold fs14 light-grey mt10">
                Appointment <span className="red-color">*</span> :
              </div>
              <div className="ml5">
                <CustomCheckbox
                  radio
                  value={modValues?.appointmentOption}
                  onChange={(e) =>
                    handleModValueChange("appointmentOption", e?.target?.value)
                  }
                  radios={
                    slctedApnt?.reAssign
                      ? appointmentList
                      : appointmentLaterList
                  }
                  disabled={slctedApnt?.reAssign}
                  defaultValue={modValues?.appointmentOption}
                />
              </div>
            </div>
            {!!modErrs?.appointmentOption && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography color="error" className="mt5 fs14">
                  Appointment is Required
                </Typography>
              </Grid>
            )}
          </Grid>
          {!slctedApnt?.reAssign &&
            modValues?.appointmentOption === "Later" && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-mont fs14 ">
                  Date <span className="red-color">*</span>
                </div>
                <div className="mb20">
                  <CustomTextField
                    name="date"
                    value={modValues?.date}
                    labelTop
                    fullWidth
                    handleChange={(e) =>
                      handleModValueChange("date", e?.target?.value)
                    }
                    mobileDateWithBatch
                    markDateList={holidayDates ?? []}
                  />
                </div>
              </Grid>
            )}

          {!slctedApnt?.reAssign &&
            modValues?.appointmentOption === "Later" &&
            modValues?.date &&
            getRequiredSlotList({
              availability: vetAvailability,
              date: modValues?.date,
              bookedApnts: vetBookedApnts,
            })?.length > 0 &&
            getRequiredSlotList({
              availability: vetAvailability,
              date: modValues?.date,
              bookedApnts: vetBookedApnts,
            })?.map((item, i) => {
              return (
                <div
                  key={i}
                  onClick={() => handleSelectTime(item)}
                  className={
                    selectTime === item?.startTime
                      ? "bgContainerSelected cursor"
                      : "bgContainerUnselected cursor"
                  }
                >
                  {item?.startTime}
                </div>
              );
            })}
          {modErrs?.timeErr && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography color="error" className="mt5 fs14">
                Time is Requried
              </Typography>
            </Grid>
          )}
        </Grid>
        <div className="flex1-end mt20">
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <CustomButton text="Save" onClick={handleReschedule} smallBtn />
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        {["Type", "Service Type"]?.includes(li) ? (
                          <CustomSelect
                            list={
                              li === "Type"
                                ? bookingTypes
                                : li === "Service Type"
                                ? serviceTypes
                                : []
                            }
                            value={filterValues?.values?.[li] ?? []}
                            name={li}
                            handleChange={onFilterValuesChange}
                            label={li}
                            multiSelectSearchCheck={li !== "Type"}
                            select={li === "Type"}
                          />
                        ) : li === "Appt Date" ? (
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="Start Date"
                                fullWidth
                                name="Start Date"
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.["Start Date"] ?? ""
                                }
                                label="Start Date"
                                mobileDate
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="End Date"
                                fullWidth
                                name="End Date"
                                handleChange={onFilterValuesChange}
                                value={filterValues?.values?.["End Date"] ?? ""}
                                label="End Date"
                                mobileDate
                              />
                            </div>
                          </div>
                        ) : li === "Appt Time" ? (
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="Start Time"
                                fullWidth
                                name="Start Time"
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.["Start Time"] ?? ""
                                }
                                label="Start Time"
                                mobileTime
                                is12HourFomat={false}
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="End Time"
                                fullWidth
                                name="End Time"
                                handleChange={onFilterValuesChange}
                                value={filterValues?.values?.["End Time"] ?? ""}
                                label="End Time"
                                mobileTime
                                is12HourFomat={false}
                              />
                            </div>
                          </div>
                        ) : (
                          <CustomTextField
                            placeholder={li}
                            fullWidth
                            name={li}
                            handleChange={onFilterValuesChange}
                            value={filterValues?.values?.[li] ?? ""}
                            label={li}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={assignVetModVisible}
        onClose={onCloseAssignVetMod}
        header={
          clinicDetails?.id === slctedApnt?.doctorId &&
          !checkIsVet(slctedApnt?.doctorId) &&
          !checkIsVet(profile?.id)
            ? "Select Vet and Facility"
            : "Select Facility"
        }
        modal
        modalWidth={30}
      >
        <div className="mh10">
          {clinicDetails?.id === slctedApnt?.doctorId &&
          !checkIsVet(slctedApnt?.doctorId) &&
          !checkIsVet(profile?.id) ? (
            <div>
              <CustomSelect
                list={getVetList()}
                handleChange={(e, value) =>
                  onAssignVetChange("vet", value, "error")
                }
                name="vet"
                label="Vet Name *"
                search
                value={assignVetvalues?.vet}
                error={!!assignVetvalues?.error}
                helperText={
                  assignVetvalues?.error ? "Vet Name is required field" : ""
                }
              />
            </div>
          ) : null}
          <div
            className={
              clinicDetails?.id === slctedApnt?.doctorId &&
              !checkIsVet(slctedApnt?.doctorId) &&
              !checkIsVet(profile?.id)
                ? "mt15"
                : ""
            }
          >
            <CustomSelect
              list={getFacilitiesByType(slctedApnt?.serviceType)}
              handleChange={(e, value) =>
                onAssignVetChange("facility", value, "facilityErr")
              }
              name="facility"
              label="Facility *"
              search
              value={assignVetvalues?.facility}
              error={!!assignVetvalues?.facilityErr}
              helperText={
                assignVetvalues?.facilityErr ? "Facility is required field" : ""
              }
            />
          </div>
          <div className="flex-center mv20">
            <div>
              <CustomButton text="Save" onClick={onAssignVet} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default NewCalendar;
